/* Ashmira Botanica — Full Biorhythm Result Data
   Updated from the corrected app biorhythm data file.
   Upload this file to Shopify assets as: ashmira-biorhythm-results.js */
window.AshmiraBiorhythmData = {
  "cycleStartYear": 1984,
  "chineseNewYearDates": {
    "1940": "1940-02-08",
    "1941": "1941-01-27",
    "1942": "1942-02-15",
    "1943": "1943-02-05",
    "1944": "1944-01-25",
    "1945": "1945-02-13",
    "1946": "1946-02-02",
    "1947": "1947-01-22",
    "1948": "1948-02-10",
    "1949": "1949-01-29",
    "1950": "1950-02-17",
    "1951": "1951-02-06",
    "1952": "1952-01-27",
    "1953": "1953-02-14",
    "1954": "1954-02-03",
    "1955": "1955-01-24",
    "1956": "1956-02-12",
    "1957": "1957-01-31",
    "1958": "1958-02-18",
    "1959": "1959-02-08",
    "1960": "1960-01-28",
    "1961": "1961-02-15",
    "1962": "1962-02-05",
    "1963": "1963-01-25",
    "1964": "1964-02-13",
    "1965": "1965-02-02",
    "1966": "1966-01-21",
    "1967": "1967-02-09",
    "1968": "1968-01-30",
    "1969": "1969-02-17",
    "1970": "1970-02-06",
    "1971": "1971-01-27",
    "1972": "1972-02-15",
    "1973": "1973-02-03",
    "1974": "1974-01-23",
    "1975": "1975-02-11",
    "1976": "1976-01-31",
    "1977": "1977-02-18",
    "1978": "1978-02-07",
    "1979": "1979-01-28",
    "1980": "1980-02-16",
    "1981": "1981-02-05",
    "1982": "1982-01-25",
    "1983": "1983-02-13",
    "1984": "1984-02-02",
    "1985": "1985-02-20",
    "1986": "1986-02-09",
    "1987": "1987-01-29",
    "1988": "1988-02-17",
    "1989": "1989-02-06",
    "1990": "1990-01-27",
    "1991": "1991-02-15",
    "1992": "1992-02-04",
    "1993": "1993-01-23",
    "1994": "1994-02-10",
    "1995": "1995-01-31",
    "1996": "1996-02-19",
    "1997": "1997-02-07",
    "1998": "1998-01-28",
    "1999": "1999-02-16",
    "2000": "2000-02-05",
    "2001": "2001-01-24",
    "2002": "2002-02-12",
    "2003": "2003-02-01",
    "2004": "2004-01-22",
    "2005": "2005-02-09",
    "2006": "2006-01-29",
    "2007": "2007-02-18",
    "2008": "2008-02-07",
    "2009": "2009-01-26",
    "2010": "2010-02-14",
    "2011": "2011-02-03",
    "2012": "2012-01-23",
    "2013": "2013-02-10",
    "2014": "2014-01-31",
    "2015": "2015-02-19",
    "2016": "2016-02-08",
    "2017": "2017-01-28",
    "2018": "2018-02-16",
    "2019": "2019-02-05",
    "2020": "2020-01-25",
    "2021": "2021-02-12",
    "2022": "2022-02-01",
    "2023": "2023-01-22",
    "2024": "2024-02-10",
    "2025": "2025-01-29",
    "2026": "2026-02-17",
    "2027": "2027-02-06",
    "2028": "2028-01-26",
    "2029": "2029-02-13",
    "2030": "2030-02-03",
    "2031": "2031-01-23",
    "2032": "2032-02-11",
    "2033": "2033-01-31",
    "2034": "2034-02-19",
    "2035": "2035-02-08",
    "2036": "2036-01-28",
    "2037": "2037-02-15",
    "2038": "2038-02-04",
    "2039": "2039-01-24",
    "2040": "2040-02-12",
    "2041": "2041-02-01",
    "2042": "2042-01-22",
    "2043": "2043-02-10"
  },
  "cycleMap": [
    {
      "id": 1,
      "year": 1984,
      "traditionalName": "Wood Rat",
      "polarity": "Yang",
      "profileKey": "metal-gold-beneath-the-sea",
      "title": "METAL GOLD BENEATH THE SEA",
      "meridians": "GB/LIV  GB/LIV"
    },
    {
      "id": 2,
      "year": 1985,
      "traditionalName": "Wood Ox",
      "polarity": "Yin",
      "profileKey": "metal-gold-beneath-the-sea",
      "title": "METAL GOLD BENEATH THE SEA",
      "meridians": "GB/LIV  GB/LIV"
    },
    {
      "id": 3,
      "year": 1986,
      "traditionalName": "Fire Tiger",
      "polarity": "Yang",
      "profileKey": "fire-from-a-kiln",
      "title": "FIRE FROM A KILN",
      "meridians": "SI/TH/H.P LU/LI"
    },
    {
      "id": 4,
      "year": 1987,
      "traditionalName": "Fire Rabbit",
      "polarity": "Yin",
      "profileKey": "fire-from-a-kiln",
      "title": "FIRE FROM A KILN",
      "meridians": "SI/TH/H.P LU/LI"
    },
    {
      "id": 5,
      "year": 1988,
      "traditionalName": "Earth Dragon",
      "polarity": "Yang",
      "profileKey": "wood-trees-in-forest",
      "title": "WOOD TREES IN FOREST",
      "meridians": "STO/SPL STO/SPL"
    },
    {
      "id": 6,
      "year": 1989,
      "traditionalName": "Earth Snake",
      "polarity": "Yin",
      "profileKey": "wood-trees-in-forest",
      "title": "WOOD TREES IN FOREST",
      "meridians": "STO/SPL STO/SPL"
    },
    {
      "id": 7,
      "year": 1990,
      "traditionalName": "Metal Horse",
      "polarity": "Yang",
      "profileKey": "earth-path",
      "title": "EARTH PATH",
      "meridians": "LI/LU H/SI"
    },
    {
      "id": 8,
      "year": 1991,
      "traditionalName": "Metal Sheep",
      "polarity": "Yin",
      "profileKey": "earth-path",
      "title": "EARTH PATH",
      "meridians": "LI/LU H/SI"
    },
    {
      "id": 9,
      "year": 1992,
      "traditionalName": "Water Monkey",
      "polarity": "Yang",
      "profileKey": "metal-gold-tip-of-sword",
      "title": "METAL GOLD TIP OF SWORD",
      "meridians": "B/K B/K"
    },
    {
      "id": 10,
      "year": 1993,
      "traditionalName": "Water Rooster",
      "polarity": "Yin",
      "profileKey": "metal-gold-tip-of-sword",
      "title": "METAL GOLD TIP OF SWORD",
      "meridians": "B/K B/K"
    },
    {
      "id": 11,
      "year": 1994,
      "traditionalName": "Wood Dog",
      "polarity": "Yang",
      "profileKey": "fire-on-a-mountain-top",
      "title": "FIRE ON A MOUNTAIN TOP",
      "meridians": "GB/LIV P/TW"
    },
    {
      "id": 12,
      "year": 1995,
      "traditionalName": "Wood Pig",
      "polarity": "Yin",
      "profileKey": "fire-on-a-mountain-top",
      "title": "FIRE ON A MOUNTAIN TOP",
      "meridians": "GB/LIV P/TW"
    },
    {
      "id": 13,
      "year": 1996,
      "traditionalName": "Fire Rat",
      "polarity": "Yang",
      "profileKey": "water-flowing",
      "title": "WATER FROM RIVER",
      "meridians": "SI/TH H/P GB LIV"
    },
    {
      "id": 14,
      "year": 1997,
      "traditionalName": "Fire Ox",
      "polarity": "Yin",
      "profileKey": "water-flowing",
      "title": "WATER FROM RIVER",
      "meridians": "SI/TH H/P GB LIV"
    },
    {
      "id": 15,
      "year": 1998,
      "traditionalName": "Earth Tiger",
      "polarity": "Yang",
      "profileKey": "earth-rampart",
      "title": "EARTH RAMPART",
      "meridians": "STO/SPL LU/LI"
    },
    {
      "id": 16,
      "year": 1999,
      "traditionalName": "Earth Rabbit",
      "polarity": "Yin",
      "profileKey": "earth-rampart",
      "title": "EARTH RAMPART",
      "meridians": "STO/SPL LU/LI"
    },
    {
      "id": 17,
      "year": 2000,
      "traditionalName": "Metal Dragon",
      "polarity": "Yang",
      "profileKey": "metal-gold-candlestick",
      "title": "METAL GOLD CANDLESTICK",
      "meridians": "LI/LU STO/SPL"
    },
    {
      "id": 18,
      "year": 2001,
      "traditionalName": "Metal Snake",
      "polarity": "Yin",
      "profileKey": "metal-gold-candlestick",
      "title": "METAL GOLD CANDLESTICK",
      "meridians": "LI/LU STO/SPL"
    },
    {
      "id": 19,
      "year": 2002,
      "traditionalName": "Water Horse",
      "polarity": "Yang",
      "profileKey": "wood-weeping-willow",
      "title": "WOOD WEEPING WILLOW",
      "meridians": "B/K H/SI"
    },
    {
      "id": 20,
      "year": 2003,
      "traditionalName": "Water Sheep",
      "polarity": "Yin",
      "profileKey": "wood-weeping-willow",
      "title": "WOOD WEEPING WILLOW",
      "meridians": "B/K H/SI"
    },
    {
      "id": 21,
      "year": 2004,
      "traditionalName": "Wood Monkey",
      "polarity": "Yang",
      "profileKey": "water-from-the-well",
      "title": "WATER FROM THE WELL",
      "meridians": "GB/LIV B/K"
    },
    {
      "id": 22,
      "year": 2005,
      "traditionalName": "Wood Rooster",
      "polarity": "Yin",
      "profileKey": "water-from-the-well",
      "title": "WATER FROM THE WELL",
      "meridians": "GB/LIV B/K"
    },
    {
      "id": 23,
      "year": 2006,
      "traditionalName": "Fire Dog",
      "polarity": "Yang",
      "profileKey": "earth-roof",
      "title": "EARTH ROOF",
      "meridians": "SI/TH H.P P/TW"
    },
    {
      "id": 24,
      "year": 2007,
      "traditionalName": "Fire Pig",
      "polarity": "Yin",
      "profileKey": "earth-roof",
      "title": "EARTH ROOF",
      "meridians": "SI/TH H.P P/TW"
    },
    {
      "id": 25,
      "year": 2008,
      "traditionalName": "Earth Rat",
      "polarity": "Yang",
      "profileKey": "fire-lightening",
      "title": "FIRE LIGHTENING",
      "meridians": "STO/SPL GB/LIV"
    },
    {
      "id": 26,
      "year": 2009,
      "traditionalName": "Earth Ox",
      "polarity": "Yin",
      "profileKey": "fire-lightening",
      "title": "FIRE LIGHTENING",
      "meridians": "STO/SPL GB/LIV"
    },
    {
      "id": 27,
      "year": 2010,
      "traditionalName": "Metal Tiger",
      "polarity": "Yang",
      "profileKey": "wood-pine",
      "title": "WOOD PINE",
      "meridians": "LI/LU LU/LI"
    },
    {
      "id": 28,
      "year": 2011,
      "traditionalName": "Metal Rabbit",
      "polarity": "Yin",
      "profileKey": "wood-pine",
      "title": "WOOD PINE",
      "meridians": "LI/LU LU/LI"
    },
    {
      "id": 29,
      "year": 2012,
      "traditionalName": "Water Dragon",
      "polarity": "Yang",
      "profileKey": "water-flowing-long",
      "title": "WATER FLOWING",
      "meridians": "B/K STO/SPL"
    },
    {
      "id": 30,
      "year": 2013,
      "traditionalName": "Water Snake",
      "polarity": "Yin",
      "profileKey": "water-flowing-long",
      "title": "WATER FLOWING",
      "meridians": "B/K STO/SPL"
    },
    {
      "id": 31,
      "year": 2014,
      "traditionalName": "Wood Horse",
      "polarity": "Yang",
      "profileKey": "metal-gold-beneath-the-sand",
      "title": "METAL GOLD BENEATH THE SAND",
      "meridians": "GB/LIV H/SI"
    },
    {
      "id": 32,
      "year": 2015,
      "traditionalName": "Wood Sheep",
      "polarity": "Yin",
      "profileKey": "metal-gold-beneath-the-sand",
      "title": "METAL GOLD BENEATH THE SAND",
      "meridians": "GB/LIV H/SI"
    },
    {
      "id": 33,
      "year": 2016,
      "traditionalName": "Fire Monkey",
      "polarity": "Yang",
      "profileKey": "fire-at-base-of-mountain",
      "title": "FIRE AT BASE OF MOUNTAIN",
      "meridians": "SI.TH/H.P B/K"
    },
    {
      "id": 34,
      "year": 2017,
      "traditionalName": "Fire Rooster",
      "polarity": "Yin",
      "profileKey": "fire-at-base-of-mountain",
      "title": "FIRE AT BASE OF MOUNTAIN",
      "meridians": "SI.TH/H.P B/K"
    },
    {
      "id": 35,
      "year": 2018,
      "traditionalName": "Earth Dog",
      "polarity": "Yang",
      "profileKey": "wood-trees-on-a-plane",
      "title": "WOOD TREES ON A PLANE",
      "meridians": "STO/SPL P/TW"
    },
    {
      "id": 36,
      "year": 2019,
      "traditionalName": "Earth Pig",
      "polarity": "Yin",
      "profileKey": "wood-trees-on-a-plane",
      "title": "WOOD TREES ON A PLANE",
      "meridians": "STO/SPL P/TW"
    },
    {
      "id": 37,
      "year": 2020,
      "traditionalName": "Metal Rat",
      "polarity": "Yang",
      "profileKey": "earth-wall",
      "title": "EARTH WALL",
      "meridians": "LI/LU GB/LIV"
    },
    {
      "id": 38,
      "year": 2021,
      "traditionalName": "Metal Ox",
      "polarity": "Yin",
      "profileKey": "earth-wall",
      "title": "EARTH WALL",
      "meridians": "LI/LU GB/LIV"
    },
    {
      "id": 39,
      "year": 2022,
      "traditionalName": "Water Tiger",
      "polarity": "Yang",
      "profileKey": "metal-white-gold",
      "title": "METAL WHITE GOLD",
      "meridians": "B/K LU/LI"
    },
    {
      "id": 40,
      "year": 2023,
      "traditionalName": "Water Rabbit",
      "polarity": "Yin",
      "profileKey": "metal-white-gold",
      "title": "METAL WHITE GOLD",
      "meridians": "B/K LU/LI"
    },
    {
      "id": 41,
      "year": 2024,
      "traditionalName": "Wood Dragon",
      "polarity": "Yang",
      "profileKey": "fire-flame-candle",
      "title": "FIRE FLAME CANDLE",
      "meridians": "GB/LIV STO/SPL"
    },
    {
      "id": 42,
      "year": 2025,
      "traditionalName": "Wood Snake",
      "polarity": "Yin",
      "profileKey": "fire-flame-candle",
      "title": "FIRE FLAME CANDLE",
      "meridians": "GB/LIV STO/SPL"
    },
    {
      "id": 43,
      "year": 2026,
      "traditionalName": "Fire Horse",
      "polarity": "Yang",
      "profileKey": "water-from-the-sky",
      "title": "WATER FROM THE SKY",
      "meridians": "SI.TH H.P H/SI"
    },
    {
      "id": 44,
      "year": 2027,
      "traditionalName": "Fire Sheep",
      "polarity": "Yin",
      "profileKey": "water-from-the-sky",
      "title": "WATER FROM THE SKY",
      "meridians": "SI.TH H.P H/SI"
    },
    {
      "id": 45,
      "year": 2028,
      "traditionalName": "Earth Monkey",
      "polarity": "Yang",
      "profileKey": "earth-floor",
      "title": "EARTH FLOOR",
      "meridians": "STO/SPL B/K"
    },
    {
      "id": 46,
      "year": 2029,
      "traditionalName": "Earth Rooster",
      "polarity": "Yin",
      "profileKey": "earth-floor",
      "title": "EARTH FLOOR",
      "meridians": "STO/SPL B/K"
    },
    {
      "id": 47,
      "year": 2030,
      "traditionalName": "Metal Dog",
      "polarity": "Yang",
      "profileKey": "metal-gold-jewellery",
      "title": "METAL GOLD JEWELLERY",
      "meridians": "LI/LU P/TH"
    },
    {
      "id": 48,
      "year": 2031,
      "traditionalName": "Metal Pig",
      "polarity": "Yin",
      "profileKey": "metal-gold-jewellery",
      "title": "METAL GOLD JEWELLERY",
      "meridians": "LI/LU P/TH"
    },
    {
      "id": 49,
      "year": 2032,
      "traditionalName": "Water Rat",
      "polarity": "Yang",
      "profileKey": "wood-mulberry-tree",
      "title": "WOOD MULBERRY TREE",
      "meridians": "B/K GB/LIV"
    },
    {
      "id": 50,
      "year": 2033,
      "traditionalName": "Water Ox",
      "polarity": "Yin",
      "profileKey": "wood-mulberry-tree",
      "title": "WOOD MULBERRY TREE",
      "meridians": "B/K GB/LIV"
    },
    {
      "id": 51,
      "year": 2034,
      "traditionalName": "Wood Tiger",
      "polarity": "Yang",
      "profileKey": "water-waterfall",
      "title": "WATER WATERFALL",
      "meridians": "GB/LIV LU/LI"
    },
    {
      "id": 52,
      "year": 2035,
      "traditionalName": "Wood Rabbit",
      "polarity": "Yin",
      "profileKey": "water-waterfall",
      "title": "WATER WATERFALL",
      "meridians": "GB/LIV LU/LI"
    },
    {
      "id": 53,
      "year": 2036,
      "traditionalName": "Fire Dragon",
      "polarity": "Yang",
      "profileKey": "earth-in-sand",
      "title": "EARTH IN SAND",
      "meridians": "SI/TH H/P STO/SPL"
    },
    {
      "id": 54,
      "year": 2037,
      "traditionalName": "Fire Snake",
      "polarity": "Yin",
      "profileKey": "earth-in-sand",
      "title": "EARTH IN SAND",
      "meridians": "SI/TH H/P STO/SPL"
    },
    {
      "id": 55,
      "year": 2038,
      "traditionalName": "Earth Horse",
      "polarity": "Yang",
      "profileKey": "fire-sun",
      "title": "FIRE SUN",
      "meridians": "STO/SPL H/SI"
    },
    {
      "id": 56,
      "year": 2039,
      "traditionalName": "Earth Sheep",
      "polarity": "Yin",
      "profileKey": "fire-sun",
      "title": "FIRE SUN",
      "meridians": "STO/SPL H/SI"
    },
    {
      "id": 57,
      "year": 2040,
      "traditionalName": "Metal Monkey",
      "polarity": "Yang",
      "profileKey": "wood-pomegranate-tree",
      "title": "WOOD POMEGRANATE TREE",
      "meridians": "LI/LU B/K"
    },
    {
      "id": 58,
      "year": 2041,
      "traditionalName": "Metal Rooster",
      "polarity": "Yin",
      "profileKey": "wood-pomegranate-tree",
      "title": "WOOD POMEGRANATE TREE",
      "meridians": "LI/LU B/K"
    },
    {
      "id": 59,
      "year": 2042,
      "traditionalName": "Water Dog",
      "polarity": "Yang",
      "profileKey": "water-vast-ocean",
      "title": "WATER VAST OCEAN",
      "meridians": "B/K P/TW"
    },
    {
      "id": 60,
      "year": 2043,
      "traditionalName": "Water Pig",
      "polarity": "Yin",
      "profileKey": "water-vast-ocean",
      "title": "WATER VAST OCEAN",
      "meridians": "B/K P/TW"
    }
  ],
  "yearProfileMap": {
    "1900": {
      "profileKey": "earth-wall",
      "polarity": "Yang"
    },
    "1901": {
      "profileKey": "earth-wall",
      "polarity": "Yin"
    },
    "1902": {
      "profileKey": "metal-white-gold",
      "polarity": "Yang"
    },
    "1903": {
      "profileKey": "metal-white-gold",
      "polarity": "Yin"
    },
    "1904": {
      "profileKey": "fire-flame-candle",
      "polarity": "Yang"
    },
    "1905": {
      "profileKey": "fire-flame-candle",
      "polarity": "Yin"
    },
    "1906": {
      "profileKey": "water-from-the-sky",
      "polarity": "Yang"
    },
    "1907": {
      "profileKey": "water-from-the-sky",
      "polarity": "Yin"
    },
    "1908": {
      "profileKey": "earth-floor",
      "polarity": "Yang"
    },
    "1909": {
      "profileKey": "earth-floor",
      "polarity": "Yin"
    },
    "1910": {
      "profileKey": "metal-gold-jewellery",
      "polarity": "Yang"
    },
    "1911": {
      "profileKey": "metal-gold-jewellery",
      "polarity": "Yin"
    },
    "1912": {
      "profileKey": "wood-mulberry-tree",
      "polarity": "Yang"
    },
    "1913": {
      "profileKey": "wood-mulberry-tree",
      "polarity": "Yin"
    },
    "1914": {
      "profileKey": "water-waterfall",
      "polarity": "Yang"
    },
    "1915": {
      "profileKey": "water-waterfall",
      "polarity": "Yin"
    },
    "1916": {
      "profileKey": "earth-in-sand",
      "polarity": "Yang"
    },
    "1917": {
      "profileKey": "earth-in-sand",
      "polarity": "Yin"
    },
    "1918": {
      "profileKey": "fire-sun",
      "polarity": "Yang"
    },
    "1919": {
      "profileKey": "fire-sun",
      "polarity": "Yin"
    },
    "1920": {
      "profileKey": "wood-pomegranate-tree",
      "polarity": "Yang"
    },
    "1921": {
      "profileKey": "wood-pomegranate-tree",
      "polarity": "Yin"
    },
    "1922": {
      "profileKey": "water-vast-ocean",
      "polarity": "Yang"
    },
    "1923": {
      "profileKey": "water-vast-ocean",
      "polarity": "Yin"
    },
    "1924": {
      "profileKey": "metal-gold-beneath-the-sea",
      "polarity": "Yang"
    },
    "1925": {
      "profileKey": "metal-gold-beneath-the-sea",
      "polarity": "Yin"
    },
    "1926": {
      "profileKey": "fire-from-a-kiln",
      "polarity": "Yang"
    },
    "1927": {
      "profileKey": "fire-from-a-kiln",
      "polarity": "Yin"
    },
    "1928": {
      "profileKey": "wood-trees-in-forest",
      "polarity": "Yang"
    },
    "1929": {
      "profileKey": "wood-trees-in-forest",
      "polarity": "Yin"
    },
    "1930": {
      "profileKey": "earth-path",
      "polarity": "Yang"
    },
    "1931": {
      "profileKey": "earth-path",
      "polarity": "Yin"
    },
    "1932": {
      "profileKey": "metal-gold-tip-of-sword",
      "polarity": "Yang"
    },
    "1933": {
      "profileKey": "metal-gold-tip-of-sword",
      "polarity": "Yin"
    },
    "1934": {
      "profileKey": "fire-on-a-mountain-top",
      "polarity": "Yang"
    },
    "1935": {
      "profileKey": "fire-on-a-mountain-top",
      "polarity": "Yin"
    },
    "1936": {
      "profileKey": "water-flowing",
      "polarity": "Yang"
    },
    "1937": {
      "profileKey": "water-flowing",
      "polarity": "Yin"
    },
    "1938": {
      "profileKey": "earth-rampart",
      "polarity": "Yang"
    },
    "1939": {
      "profileKey": "earth-rampart",
      "polarity": "Yin"
    },
    "1940": {
      "profileKey": "metal-gold-candlestick",
      "polarity": "Yang"
    },
    "1941": {
      "profileKey": "metal-gold-candlestick",
      "polarity": "Yin"
    },
    "1942": {
      "profileKey": "wood-weeping-willow",
      "polarity": "Yang"
    },
    "1943": {
      "profileKey": "wood-weeping-willow",
      "polarity": "Yin"
    },
    "1944": {
      "profileKey": "water-from-the-well",
      "polarity": "Yang"
    },
    "1945": {
      "profileKey": "water-from-the-well",
      "polarity": "Yin"
    },
    "1946": {
      "profileKey": "earth-roof",
      "polarity": "Yang"
    },
    "1947": {
      "profileKey": "earth-roof",
      "polarity": "Yin"
    },
    "1948": {
      "profileKey": "fire-lightening",
      "polarity": "Yang"
    },
    "1949": {
      "profileKey": "fire-lightening",
      "polarity": "Yin"
    },
    "1950": {
      "profileKey": "wood-pine",
      "polarity": "Yang"
    },
    "1951": {
      "profileKey": "wood-pine",
      "polarity": "Yin"
    },
    "1952": {
      "profileKey": "water-flowing-long",
      "polarity": "Yang"
    },
    "1953": {
      "profileKey": "water-flowing-long",
      "polarity": "Yin"
    },
    "1954": {
      "profileKey": "metal-gold-beneath-the-sand",
      "polarity": "Yang"
    },
    "1955": {
      "profileKey": "metal-gold-beneath-the-sand",
      "polarity": "Yin"
    },
    "1956": {
      "profileKey": "fire-at-base-of-mountain",
      "polarity": "Yang"
    },
    "1957": {
      "profileKey": "fire-at-base-of-mountain",
      "polarity": "Yin"
    },
    "1958": {
      "profileKey": "wood-trees-on-a-plane",
      "polarity": "Yang"
    },
    "1959": {
      "profileKey": "wood-trees-on-a-plane",
      "polarity": "Yin"
    },
    "1960": {
      "profileKey": "earth-wall",
      "polarity": "Yang"
    },
    "1961": {
      "profileKey": "earth-wall",
      "polarity": "Yin"
    },
    "1962": {
      "profileKey": "metal-white-gold",
      "polarity": "Yang"
    },
    "1963": {
      "profileKey": "metal-white-gold",
      "polarity": "Yin"
    },
    "1964": {
      "profileKey": "fire-flame-candle",
      "polarity": "Yang"
    },
    "1965": {
      "profileKey": "fire-flame-candle",
      "polarity": "Yin"
    },
    "1966": {
      "profileKey": "water-from-the-sky",
      "polarity": "Yang"
    },
    "1967": {
      "profileKey": "water-from-the-sky",
      "polarity": "Yin"
    },
    "1968": {
      "profileKey": "earth-floor",
      "polarity": "Yang"
    },
    "1969": {
      "profileKey": "earth-floor",
      "polarity": "Yin"
    },
    "1970": {
      "profileKey": "metal-gold-jewellery",
      "polarity": "Yang"
    },
    "1971": {
      "profileKey": "metal-gold-jewellery",
      "polarity": "Yin"
    },
    "1972": {
      "profileKey": "wood-mulberry-tree",
      "polarity": "Yang"
    },
    "1973": {
      "profileKey": "wood-mulberry-tree",
      "polarity": "Yin"
    },
    "1974": {
      "profileKey": "water-waterfall",
      "polarity": "Yang"
    },
    "1975": {
      "profileKey": "water-waterfall",
      "polarity": "Yin"
    },
    "1976": {
      "profileKey": "earth-in-sand",
      "polarity": "Yang"
    },
    "1977": {
      "profileKey": "earth-in-sand",
      "polarity": "Yin"
    },
    "1978": {
      "profileKey": "fire-sun",
      "polarity": "Yang"
    },
    "1979": {
      "profileKey": "fire-sun",
      "polarity": "Yin"
    },
    "1980": {
      "profileKey": "wood-pomegranate-tree",
      "polarity": "Yang"
    },
    "1981": {
      "profileKey": "wood-pomegranate-tree",
      "polarity": "Yin"
    },
    "1982": {
      "profileKey": "water-vast-ocean",
      "polarity": "Yang"
    },
    "1983": {
      "profileKey": "water-vast-ocean",
      "polarity": "Yin"
    },
    "1984": {
      "profileKey": "metal-gold-beneath-the-sea",
      "polarity": "Yang"
    },
    "1985": {
      "profileKey": "metal-gold-beneath-the-sea",
      "polarity": "Yin"
    },
    "1986": {
      "profileKey": "fire-from-a-kiln",
      "polarity": "Yang"
    },
    "1987": {
      "profileKey": "fire-from-a-kiln",
      "polarity": "Yin"
    },
    "1988": {
      "profileKey": "wood-trees-in-forest",
      "polarity": "Yang"
    },
    "1989": {
      "profileKey": "wood-trees-in-forest",
      "polarity": "Yin"
    },
    "1990": {
      "profileKey": "earth-path",
      "polarity": "Yang"
    },
    "1991": {
      "profileKey": "earth-path",
      "polarity": "Yin"
    },
    "1992": {
      "profileKey": "metal-gold-tip-of-sword",
      "polarity": "Yang"
    },
    "1993": {
      "profileKey": "metal-gold-tip-of-sword",
      "polarity": "Yin"
    },
    "1994": {
      "profileKey": "fire-on-a-mountain-top",
      "polarity": "Yang"
    },
    "1995": {
      "profileKey": "fire-on-a-mountain-top",
      "polarity": "Yin"
    },
    "1996": {
      "profileKey": "water-flowing",
      "polarity": "Yang"
    },
    "1997": {
      "profileKey": "water-flowing",
      "polarity": "Yin"
    },
    "1998": {
      "profileKey": "earth-rampart",
      "polarity": "Yang"
    },
    "1999": {
      "profileKey": "earth-rampart",
      "polarity": "Yin"
    },
    "2000": {
      "profileKey": "metal-gold-candlestick",
      "polarity": "Yang"
    },
    "2001": {
      "profileKey": "metal-gold-candlestick",
      "polarity": "Yin"
    },
    "2002": {
      "profileKey": "wood-weeping-willow",
      "polarity": "Yang"
    },
    "2003": {
      "profileKey": "wood-weeping-willow",
      "polarity": "Yin"
    },
    "2004": {
      "profileKey": "water-from-the-well",
      "polarity": "Yang"
    },
    "2005": {
      "profileKey": "water-from-the-well",
      "polarity": "Yin"
    },
    "2006": {
      "profileKey": "earth-roof",
      "polarity": "Yang"
    },
    "2007": {
      "profileKey": "earth-roof",
      "polarity": "Yin"
    },
    "2008": {
      "profileKey": "fire-lightening",
      "polarity": "Yang"
    },
    "2009": {
      "profileKey": "fire-lightening",
      "polarity": "Yin"
    },
    "2010": {
      "profileKey": "wood-pine",
      "polarity": "Yang"
    },
    "2011": {
      "profileKey": "wood-pine",
      "polarity": "Yin"
    },
    "2012": {
      "profileKey": "water-flowing-long",
      "polarity": "Yang"
    },
    "2013": {
      "profileKey": "water-flowing-long",
      "polarity": "Yin"
    },
    "2014": {
      "profileKey": "metal-gold-beneath-the-sand",
      "polarity": "Yang"
    },
    "2015": {
      "profileKey": "metal-gold-beneath-the-sand",
      "polarity": "Yin"
    },
    "2016": {
      "profileKey": "fire-at-base-of-mountain",
      "polarity": "Yang"
    },
    "2017": {
      "profileKey": "fire-at-base-of-mountain",
      "polarity": "Yin"
    },
    "2018": {
      "profileKey": "wood-trees-on-a-plane",
      "polarity": "Yang"
    },
    "2019": {
      "profileKey": "wood-trees-on-a-plane",
      "polarity": "Yin"
    },
    "2020": {
      "profileKey": "earth-wall",
      "polarity": "Yang"
    },
    "2021": {
      "profileKey": "earth-wall",
      "polarity": "Yin"
    },
    "2022": {
      "profileKey": "metal-white-gold",
      "polarity": "Yang"
    },
    "2023": {
      "profileKey": "metal-white-gold",
      "polarity": "Yin"
    },
    "2024": {
      "profileKey": "fire-flame-candle",
      "polarity": "Yang"
    },
    "2025": {
      "profileKey": "fire-flame-candle",
      "polarity": "Yin"
    },
    "2026": {
      "profileKey": "water-from-the-sky",
      "polarity": "Yang"
    },
    "2027": {
      "profileKey": "water-from-the-sky",
      "polarity": "Yin"
    },
    "2028": {
      "profileKey": "earth-floor",
      "polarity": "Yang"
    },
    "2029": {
      "profileKey": "earth-floor",
      "polarity": "Yin"
    },
    "2030": {
      "profileKey": "metal-gold-jewellery",
      "polarity": "Yang"
    },
    "2031": {
      "profileKey": "metal-gold-jewellery",
      "polarity": "Yin"
    },
    "2032": {
      "profileKey": "wood-mulberry-tree",
      "polarity": "Yang"
    },
    "2033": {
      "profileKey": "wood-mulberry-tree",
      "polarity": "Yin"
    },
    "2034": {
      "profileKey": "water-waterfall",
      "polarity": "Yang"
    },
    "2035": {
      "profileKey": "water-waterfall",
      "polarity": "Yin"
    },
    "2036": {
      "profileKey": "earth-in-sand",
      "polarity": "Yang"
    },
    "2037": {
      "profileKey": "earth-in-sand",
      "polarity": "Yin"
    },
    "2038": {
      "profileKey": "fire-sun",
      "polarity": "Yang"
    },
    "2039": {
      "profileKey": "fire-sun",
      "polarity": "Yin"
    },
    "2040": {
      "profileKey": "wood-pomegranate-tree",
      "polarity": "Yang"
    },
    "2041": {
      "profileKey": "wood-pomegranate-tree",
      "polarity": "Yin"
    },
    "2042": {
      "profileKey": "water-vast-ocean",
      "polarity": "Yang"
    },
    "2043": {
      "profileKey": "water-vast-ocean",
      "polarity": "Yin"
    }
  },
  "profiles": {
    "metal-gold-beneath-the-sea": {
      "title": "METAL GOLD BENEATH THE SEA",
      "element": "Metal",
      "meridians": "GB/LIV  GB/LIV",
      "mainDescription": "Metal is valuable and, in this biorhythm, represents a form of treasure. One of this person’s most valuable qualities, and their ‘treasure’, comes from their imagination. They think creatively and have lots of ideas, this comes from the Wood (GB/LIV) in their biorhythm. Using their imagination requires a lot of energy, many people want to find this treasure at the bottom of the sea, but it takes someone with a lot of energy to achieve it. Having a wonderful imagination and achieving challenging goals is like finding treasure underwater - both require significant energy and effort, and when in balance this person can achieve it.",
      "generalTitle": "General Description of Metal Personalities",
      "generalDescription": "When out of balance Metal people can be hyper critical, over disciplined, direct and cold. They may wallow in grief, lose their self-worth and become depressed. A Metal personality is meticulous, honest, and responsible. Their personalities tend to be melancholy, and they may suffer from constipation, lung and skin issues, or allergies. Someone with a strong Metal element is usually very self- disciplined and organised. When an imbalance occurs in this element, the individual can feel very sad and melancholy and can develop problems related to the lungs, such as recurring colds, allergies and asthma. They feel more comfortable with clearly defined boundaries, rules, and expectations. When out of balance some of the emotional symptoms they might experience are apathy, boredom, grief, an inability to let go of the past, a lack of inspiration, melancholy, sadness and timidity.",
      "attributes": {
        "organs": "Lungs and Large Intestine",
        "season": "Autumn",
        "weather": "Dry",
        "emotion": "Grief",
        "colour": "White/Blue",
        "bodyTissue": "Skin",
        "sensation": "Smell",
        "senseOrgan": "Nose",
        "sound": "Weeping",
        "taste": "Spicy"
      },
      "physicalBoxTitle": "Gall Bladder/Liver – Wood",
      "physicalBoxText": "Physically this person also needs to keep their GB or LIV meridians balanced. An imbalance could create oiliness or dryness in their skin due to an imbalance of sebum, poor or excellent eyesight and muscular aches and pains.",
      "emotionalBoxTitle": "Gall Bladder/Liver – Wood",
      "emotionalBoxText": "This person has a lot of the emotional traits of a wood personality as well as the personality of their main element. A Wood personality can experience frustration and grumpiness, they may get a little ‘aggy’ or aggravated. They like to plan and organise. When they feel angry or frustrated, they should head to the gym or do something creative to help ease their feelings. Very often these people are very creative."
    },
    "fire-from-a-kiln": {
      "title": "FIRE FROM A KILN",
      "element": "Fire",
      "meridians": "SI/TH/H.P LU/LI",
      "mainDescription": "This person is warm and passionate. They are very sensitive but often have trouble expressing their feelings. They are very enthusiastic and can cope with all kinds of difficult situations. They are very generous, warm and loving and very family orientated. When their energy is blocked, they have problems communicating and can keep their problems locked up inside of themselves. They should try to share their problems as this would help, but they find it hard to trust that others would be able listen to them and give them good advice. These people are very generous. They can tend to be sad and melancholy at times.",
      "generalTitle": "General Description of Fire Personalities",
      "generalDescription": "When in balance a Fire person likes to step into the limelight, showing off their gifts and beauty, sharing their truth. They love to be the centre of attention and feel full of love, joy and passion. Individuals with a strong element of fire usually have a very charismatic personality. They can be quick tempered, but their temper goes as fast as it came. They make excellent leaders; they are friendly and are very good at socialising. They wear their hearts on their sleeves, and you know exactly how they are feeling. They can be loud and full of energy, they attract people to them and to their energy and because of this they normally have a large circle of friends When Fire energy is out of balance, they can be impulsive and on occasion get irritable. Fire personalities may find it hard to express themselves when they are blocked and find that their words get stuck in their throats which can lead to confusion, insomnia and speech problems. Their circulation can either be very good or they can suffer from cold hands and feet. They may perspire very little or excessively. Fire people often have broken capillaries",
      "attributes": {
        "organs": "Heart, Small Intestine, Pericardium, Triple Warmer",
        "season": "Summer",
        "weather": "Heat",
        "emotion": "Joy",
        "colour": "Red",
        "bodyTissue": "Blood Vessels",
        "sensation": "Taste",
        "senseOrgan": "Tongue",
        "sound": "Laughing",
        "taste": "Bitter"
      },
      "physicalBoxTitle": "Small Intestine/Triple Warmer Heart Pericardium – Fire",
      "physicalBoxText": "Physically this person may have problems with their circulation. They may get cold hands and feet or warm hands and feet. They may also find they either perspire excessively or not at all.",
      "emotionalBoxTitle": "Lungs/Large Intestine – Metal",
      "emotionalBoxText": "This person will also take on the emotional personality traits of a Metal Element. They may be very sensitive individuals and when something upsets or hurts them, they may find that they find it hard to let it go. They may still be holding on to things that hurt them years ago."
    },
    "wood-trees-in-forest": {
      "title": "WOOD TREES IN FOREST",
      "element": "Wood",
      "meridians": "STO/SPL STO/SPL",
      "mainDescription": "Picture a group of trees together in one place in a forest - the atmosphere is wet (which comes from the STO), this gives a good foundation for trees and plants to grow. This person needs to be surrounded by others; they do not like to be alone. They need others around them that think like they do – they like to communicate with others who think the same. Those born in the Yang year are very creative and show their creativity whereas those born in the Yin year show their creativity, but they have more difficulty in putting their ideas into action.",
      "generalTitle": "General Description of Wood Personalities",
      "generalDescription": "Wood people may be seen as athletic, energetic, and adventurous. Their body type is generally muscled, and they easily obtain muscular definition when they work out. Their body shape is often long and strong like a tree. They have their best ideas at night and therefore tend to stay up late and hate early mornings! However, if this person’s energy is out of balance, they may feel stuck. They may find themselves unable to move forward or to plan their futures. Wood’s upsurging energy doesn’t like to be stuck or blocked, and therefore emotions of frustration and irritability can build up inside them like a pressure cooker. They may have angry outbursts and mood swings, and challenges become stressful to them. When blocked they may find they lose sight of their goals and visions and flitter between plans and stop looking to the future. Their optimism, energy and creativity fades. Wood personalities when blocked, tend to be anxious and angry. They may suffer from muscular aches and pains, migraines or headaches. They may have eye strain or eyesight problems. To re-balance avoid tv and computer screens, walk in a wood, look at the green beauty of the outside and breathe in natures energy. When in balance they are life’s organisers and planners and make great leaders.",
      "attributes": {
        "organs": "Liver and Gallbladder",
        "season": "Spring",
        "weather": "Wind",
        "emotion": "Anger",
        "colour": "Green",
        "bodyTissue": "Muscles and Tendons",
        "senseOrgan": "Eyes",
        "sound": "Shouting",
        "taste": "Sour"
      },
      "physicalBoxTitle": "Stomach/Spleen - Earth",
      "physicalBoxText": "This person needs to watch their stomach physically. This means they could have digestive problems or problems with their skin – perhaps dullness or spots when younger. They may also get cellulite. Eating well is really important -good healthy food, and not too many sweet things. They may get bloating or stomach issues if they become imbalanced or blocked.",
      "emotionalBoxTitle": "Stomach/Spleen – Earth",
      "emotionalBoxText": "Emotionally this person will also take on the personality traits of an Earth person. They can be nervous, a worrier, can make mountains out of molehills, may think about food a lot, and may hide their emotions"
    },
    "earth-path": {
      "title": "EARTH PATH",
      "element": "Earth",
      "meridians": "LI/LU H/SI",
      "mainDescription": "Earth Path represents a road leading forward. This person knows where they are headed and doesn’t worry about it. They know they can accomplish things and move on without any concern. Life poses no mysteries for them; they are happy to follow their own path. This person is sensitive and understands the value of things in life. They are friendly, warm, and sociable. If born in a Yang year, they will put their plans into action. They are tranquil, calm, and stress- free, believing that life provides everything they need. However, if their energy becomes blocked, they can become very nervous because they need to know that they have the potential to achieve their goals. If they are born in a Yin year, they have many ideas but often keep their dreams as daydreams. They are quite content dreaming and have no issue spending their life that way.",
      "generalTitle": "General Description of Earth Personalities",
      "generalDescription": "An Earth person is someone who is nurturing, generous, and caring. Earth personalities can be worrisome and pensive. They may suffer from abdominal issues or hormonal problems. Individuals who possess a strong element of earth are extremely compassionate and like everything in their life to be organised and balanced – neat and tidy. If their Earth element is lacking in energy someone may think too much, making mountains out of molehills and worrying excessively. This person may have digestive problems and find their stomach bloats after eating. Food is very important; they normally wake up hungry and needing breakfast – breakfast is very important for them and should be eaten between 7 and 9 in the morning. The Earth Element person is a nurturer, they enjoy hosting family gatherings and thinking about the people they love. When Earth Element is out of balance some of the emotional symptoms they might experience are: confusion, craving sweet foods, feeling ungrounded, insecurity or neediness, obsessive thoughts, being over-protective, worrying, building up walls or barriers to protect themselves and burying their heads in the sand to avoid problems.",
      "attributes": {
        "organs": "Spleen and Stomach",
        "season": "Late Summer",
        "weather": "Damp",
        "emotion": "Worry",
        "colour": "Yellow",
        "bodyTissue": "Connective Tissue",
        "sensation": "Touch",
        "senseOrgan": "Mouth, Lips",
        "sound": "Singing",
        "taste": "Sweet"
      },
      "physicalBoxTitle": "Large Intestine/Lungs – Metal",
      "physicalBoxText": "Physically this person also needs to keep their LI or LU meridians balanced. An imbalance in their LU meridian could create asthma and breathing difficulties, or they could catch colds easily. An imbalance in their LI meridian could reveal itself as IBS, bowel irregularities or perhaps bloating or food intolerances.",
      "emotionalBoxTitle": "Heart/Small Intestine – Fire",
      "emotionalBoxText": "This person will be a very warm, friendly and emotive person. They will either be very talkative or when things upset them find it hard to express themselves and get their words out"
    },
    "metal-gold-tip-of-sword": {
      "title": "METAL GOLD TIP OF SWORD",
      "element": "Metal",
      "meridians": "B/K B/K",
      "mainDescription": "The end of a sword has a sharp tip – the Chinese say that when you hold a sword, you need to be precise. This Metal person is sensitive and values everything in their life, showing precision, loyalty, and justice. They demonstrate fairness and impartiality, adhering to principles of justice in their actions and decisions. The Bladder in their biorhythm gives them a clear head and a strong will, as well as making them a good listener. They can manage enterprises and activities effectively, as they like to take control.",
      "generalTitle": "General Description of Metal Personalities",
      "generalDescription": "When out of balance Metal people can be hyper critical, over disciplined, direct and cold. They may wallow in grief, lose their self-worth and become depressed. A Metal personality is meticulous, honest, and responsible. Their personalities tend to be melancholy, and they may suffer from constipation, lung and skin issues, or allergies. Someone with a strong Metal element is usually very self-disciplined and organised. When an imbalance occurs in this element, the individual can feel very sad and melancholy and can develop problems related to the lungs, such as recurring colds, allergies and asthma. They feel more comfortable with clearly defined boundaries, rules, and expectations. When out of balance some of the emotional symptoms they might experience are apathy, boredom, grief, an inability to let go of the past, a lack of inspiration, melancholy, sadness and timidity.",
      "attributes": {
        "organs": "Lungs and Large Intestine",
        "season": "Autumn",
        "weather": "Dry",
        "emotion": "Grief",
        "colour": "White/Blue",
        "bodyTissue": "Skin",
        "sensation": "Smell",
        "senseOrgan": "Nose",
        "sound": "Weeping",
        "taste": "Spicy"
      },
      "physicalBoxTitle": "Bladder/Kidney - Water",
      "physicalBoxText": "Blockages or stagnant energy in the Bladder or Kidney meridians may mean that this person could see problems like bladder infections, cystitis, gynaecological/reproductive organ problems, hearing problems or water retention.",
      "emotionalBoxTitle": "Bladder /Kidney – Water",
      "emotionalBoxText": "These people will be strong willed and stubborn. They know what they want to get out of life, and they will go and get it. They prefer to be self employed than work for someone as they want to use their ideas. They need to make sure they don’t get burned out and may often feel tired."
    },
    "fire-on-a-mountain-top": {
      "title": "FIRE ON A MOUNTAIN TOP",
      "element": "Fire",
      "meridians": "GB/LIV P/TW",
      "mainDescription": "This person is like a volcano that you can't stop from erupting. They are very dynamic with lots of ideas, vitality and inspiration. They may be artistic, but even if not, they will be creative. This person is very passionate and knows no limit to their passions. They see no grey – just black or white – a volcano either sleeps or it erupts – there is no in- between. This person is unstoppable and goes for everything they want out of life. They are full of enthusiasm which they happily pass on to others around them. Their only problem is that they need to find some balance in their lives. They are great communicators, and people born under this biorhythm make great salespeople. They are very emotional and when something hurts or upsets them, they hide their creativity and their emotions, their words and thoughts stay deep inside of themselves, and they become introverted. It is like their words become stuck in their throat and they can no longer express themselves or their feelings. Normally, when in balance, those born under this biorhythm are very talkative and friendly, they may have a good singing voice, and wear their heart on their sleeve, everyone knows what they are thinking or feeling.",
      "generalTitle": "General Description of Fire Personalities",
      "generalDescription": "When in balance a Fire person likes to step into the limelight, showing off their gifts and beauty, sharing their truth. They love to be the centre of attention and feel full of love, joy and passion. Individuals with a strong element of fire usually have a very charismatic personality. They can be quick tempered, but their temper goes as fast as it came. They make excellent leaders; they are friendly and are very good at socialising. They wear their hearts on their sleeves, and you know exactly how they are feeling. They can be loud and full of energy, they attract people to them and to their energy and because of this they normally have a large circle of friends When Fire energy is out of balance, they can be impulsive and on occasion get irritable. Fire personalities may find it hard to express themselves when they are blocked and find that their words get stuck in their throats which can lead to confusion, insomnia and speech problems. Their circulation can either be very good or they can suffer from cold hands and feet. They may perspire very little or excessively. Fire people often have broken capillaries on their cheeks and a reddish complexion. When out of balance agitation, anxiety, continuous laughter, a lack of joy, self-love or humour may be felt along with poor self-esteem, and they may seem uncharacteristically quiet. Love is the most important thing in life to them – not always receiving love, often being able to share it.",
      "attributes": {
        "organs": "Heart, Small Intestine, Pericardium, Triple Warmer",
        "season": "Summer",
        "weather": "Heat",
        "emotion": "Joy",
        "colour": "Red",
        "bodyTissue": "Blood Vessels",
        "sensation": "Taste",
        "senseOrgan": "Tongue",
        "sound": "Laughing",
        "taste": "Bitter"
      },
      "physicalBoxTitle": "Gall Bladder/Liver – Wood",
      "physicalBoxText": "Physically this person also needs to keep their GB or LIV meridians balanced. An imbalance could create oiliness or dryness due to an imbalance of sebum in their skin, poor or excellent eyesight and muscular aches and pains.",
      "emotionalBoxTitle": "Pericardium/Triple Warmer – Fire",
      "emotionalBoxText": "This person will be a very warm, friendly and emotive person. They will either be very talkative or when things upset them find it hard to express themselves and get their words out"
    },
    "water-flowing": {
      "title": "WATER FROM RIVER",
      "element": "Water",
      "meridians": "SI/TH H/P GB LIV",
      "mainDescription": "This person puts their thoughts into action. They evolve repeatedly and are like a cat that always lands on its feet. This person learns from life's experiences. It is crucial for this person to be emotionally balanced. They need to care for others, they are unselfish and thrive on being useful. Imagine the water in a river, it provides abundant energy; it sustains villages and serves as a rich source for the country and its towns. In the past, rivers were vital communication channels between villages, carrying food and produce. This person is full of ideas and creativity, facilitating communication like a river–passionate, attentive, and an effective communicator. They will, however, always do what they want to do, even after listening to the advice of others. Being useful is a priority for them, and they have excellent memories.",
      "generalTitle": "General Description of Water Personalities",
      "generalDescription": "Someone with a strong Water element shows traits of fearlessness and determination. Such individuals have strong will power and succeed through difficulties owing to their mental strength. The organs associated with this element include the kidneys and bladder. In balance they will face their fears and vulnerabilities and then they can become successful and become the person they really are. These people normally prefer to be self-employed and are often workaholics. Out of balance they feel fearful, paranoid, indecisive and exhausted, often suffering from burn out. They may suffer from back pain, knee pain, and kidney and bladder infections. Weakness in this element can result in hearing and hair loss, fertility and sexual organ imbalances. In some cases, people born under this element can suffer with feelings of insecurity, depression, fear, feeling overwhelmed, a lack of willpower, panic attacks, paranoia and timidity. Water personalities are old souls. They are wise, reflective, and private.",
      "attributes": {
        "organs": "Kidneys and Bladder",
        "season": "Winter",
        "weather": "Cold",
        "emotion": "Fear",
        "colour": "Black",
        "bodyTissue": "Bone",
        "sensation": "Hearing",
        "senseOrgan": "Ear",
        "sound": "Groaning",
        "taste": "Salt"
      },
      "physicalBoxTitle": "Small Intestine/Triple Warmer Heart/Pericardium – Fire",
      "physicalBoxText": "Physically this person may have problems with their circulation. They may get cold hands and feet or warm hands and feet. They may also find they either perspire excessively or not at all.",
      "emotionalBoxTitle": "Gall Bladder/Liver – Wood",
      "emotionalBoxText": "This person has a lot of the emotional traits of a wood personality as well as the personality of their main element. A Wood personality can experience frustration and grumpiness, they may get a little ‘aggy’ or aggravated. They like to plan and organise. When they feel angry or frustrated, they should head to the gym or do something creative to help ease their feelings. Very often these people are very creative"
    },
    "earth-rampart": {
      "title": "EARTH RAMPART",
      "element": "Earth",
      "meridians": "STO/SPL LU/LI",
      "mainDescription": "This person is very concerned with their physical health, as feeling unwell in their body can affect their mental well-being. Earth people prioritise balance and organisation, being realistic and thoughtful. They are sensitive and value everything deeply. They have idealistic tendencies and need clear objectives. Sometimes, they can overthink and become overly sensitive, building emotional barriers around themselves to protect others from their own intensity. Despite this, they are actually quite selfless and want to shield others from their own emotions. It's crucial for them to have a balanced diet rich in minerals to keep their nervous system healthy. When feeling particularly sensitive, they may either eat a lot or not at all. Eating well is important for their overall health. During low periods, they may experience anxiety, melancholy, and sadness. It's important for them not to dwell too much on negative thoughts. They enjoy helping others and find fulfilment in being useful. However, if they feel emotionally closed off, they may isolate themselves and become anxious.",
      "generalTitle": "General Description of Earth personalities:",
      "generalDescription": "An Earth person is nurturing, generous, and caring. Earth personalities can be worrisome and pensive. They may suffer from abdominal issues or hormonal problems. Individuals who possess a strong element of earth are extremely compassionate and like everything in their life to be organised and balanced – neat and tidy. If their Earth element is lacking in energy this person may think too much, making mountains out of molehills and worrying excessively. They may have digestive problems and find their stomach bloats after eating. Food is very important; they normally wake up hungry and needing breakfast – breakfast is very important for them and should be eaten between 7 and 9 in the morning. The Earth Element person is a nurturer, they enjoy hosting family gatherings and thinking about the people they love. When Earth Element is out of balance some of the emotional symptoms they might experience are: confusion, craving sweet foods, feeling ungrounded, insecurity or neediness, obsessive thoughts, being over-protective, worrying, building up walls or barriers to protect themselves and burying their heads in the sand to avoid problems.",
      "attributes": {
        "organs": "Spleen and Stomach",
        "season": "Late Summer",
        "weather": "Damp",
        "emotion": "Worry",
        "colour": "Yellow",
        "bodyTissue": "Connective",
        "senseOrgan": "Mouth, Lips",
        "sound": "Singing",
        "taste": "Sweet"
      },
      "physicalBoxTitle": "Stomach/Spleen - Earth",
      "physicalBoxText": "This person needs to watch their stomach physically. This means they could have digestive problems or problems with their skin – perhaps dullness or spots when younger. They may also get cellulite. Eating well is really important -good healthy food, and not too many sweet things. They may get bloating or stomach issues if they become imbalanced or blocked.",
      "emotionalBoxTitle": "Lungs/Large Intestine – Metal",
      "emotionalBoxText": "This person will also take on the emotional personality traits of a Metal Element. They may be very sensitive individuals and when something upsets or hurts them, they may find that they find it hard to let it go. They may still be holding on to things that hurt them years ago."
    },
    "metal-gold-candlestick": {
      "title": "METAL GOLD CANDLESTICK",
      "element": "Metal",
      "meridians": "LI/LU STO/SPL",
      "mainDescription": "This person sees life clearly and understands everything they need to know. They have a clear mind and conscience. Their words are wise, and they make thoughtful decisions. They search for value and always carry their inner light with them. However, they keep this light to themselves. If others want to benefit from their wisdom, they need to follow this person's lead. Their wisdom is valuable, but others have to follow them to gain from it, they won't reach out to or follow others.",
      "generalTitle": "General Description Metal personalities:",
      "generalDescription": "When out of balance Metal people can be hyper critical, over disciplined, direct and cold. They may wallow in grief, lose their self-worth and become depressed. A Metal personality is meticulous, honest, and responsible. Their personalities tend to be melancholy, and they may suffer from constipation, lung and skin issues, or allergies. Someone with a strong Metal element is usually very self-disciplined and organised. When an imbalance occurs in this element, the individual can feel very sad and melancholy and can develop problems related to the lungs, such as recurring colds, allergies and asthma. They feel more comfortable with clearly defined boundaries, rules, and expectations. When out of balance some of the emotional symptoms they might experience are apathy, boredom,grief, an inability to let go of the past, a lack of inspiration, melancholy, sadness and timidity.",
      "attributes": {
        "organs": "Lungs and Large Intestine",
        "season": "Autumn",
        "weather": "Dry",
        "emotion": "Grief",
        "colour": "White/Blue",
        "bodyTissue": "Skin",
        "sensation": "Smell",
        "senseOrgan": "Nose",
        "sound": "Weeping",
        "taste": "Spicy"
      },
      "physicalBoxTitle": "Large Intestine/Lungs – Metal",
      "physicalBoxText": "Physically this person also needs to keep their LI or LU meridian balanced. An imbalance in their LU meridian could create asthma and breathing difficulties, or they could catch colds easily. An imbalance in their LI meridian could reveal itself as IBS, bowel irregularities or perhaps bloating or food intolerances.",
      "emotionalBoxTitle": "Stomach/Spleen – Earth",
      "emotionalBoxText": "Emotionally this person will also take on the personality traits of an Earth person. They can be nervous, a worrier, can make mountains out of molehills, may think about food a lot, and may hide their emotions"
    },
    "wood-weeping-willow": {
      "title": "WOOD WEEPING WILLOW",
      "element": "Wood",
      "meridians": "B/K H/SI",
      "mainDescription": "These people make good listeners - but they are very disorganised people. These individuals are exceptionally selfless and often prioritise providing for others over themselves. Imagine a Weeping Willow Tree in a park, its energy extending outward to benefit the world. Just like that weeping willow, these people are great and precise communicators; when they listen, they share what they've learned with others. They are attentive listeners, observant, and unselfish. They possess strong willpower and clarity of mind, wearing their heart on their sleeve. They facilitate warmth and social interaction between people",
      "generalTitle": "General Description of Wood Personalities",
      "generalDescription": "Wood people may be seen as athletic, energetic, and adventurous. Their body type is generally muscled, and they easily obtain muscular definition when they work out. Their body shape is often long and strong like a tree. They have their best ideas at night and therefore tend to stay up late and hate early mornings! However, if this person’s energy is out of balance, they may feel stuck. They may find themselves unable to move forward or to plan their futures. Wood’s upsurging energy doesn’t like to be stuck or blocked, and therefore emotions of frustration and irritability can build up inside them like a pressure cooker. They may have angry outbursts and mood swings, and challenges become stressful to them. When blocked they may find they lose sight of their goals and visions and flitter between plans and stop looking to the future. Their optimism, energy and creativity fades. Wood personalities when blocked, tend to be anxious and angry. They may suffer from muscular aches and pains, migraines or headaches. They may have eye strain or eyesight problems. To rebalance avoid tv and computer screens, walk in a wood, look at the green beauty of the outside and breathe in natures energy. When in balance they are life’s organisers and planners and make great leaders.",
      "attributes": {
        "organs": "Liver and Gallbladder",
        "season": "Spring",
        "weather": "Wind",
        "emotion": "Anger",
        "colour": "Green",
        "bodyTissue": "Muscles and Tendons",
        "senseOrgan": "Eyes",
        "sound": "Shouting",
        "taste": "Sour"
      },
      "physicalBoxTitle": "Large Intestine/Lungs – Metal",
      "physicalBoxText": "Physically this person also needs to keep their LI or LU meridians balanced. An imbalance in their LU meridian could create asthma and breathing difficulties, or they could catch colds easily. An imbalance in their LI meridian could reveal itself as IBS, bowel irregularities or perhaps bloating or food intolerances",
      "emotionalBoxTitle": "Stomach/Spleen – Earth",
      "emotionalBoxText": "Emotionally this person will also take on the personality traits of an Earth person. They can be nervous, a worrier, can make mountains out of molehills, may think about food a lot, and may hide their emotions"
    },
    "water-from-the-well": {
      "title": "WATER FROM THE WELL",
      "element": "Water",
      "meridians": "GB/LIV B/K",
      "mainDescription": "This person is fiercely independent, but not egotistical, although their energy may seem that way. When they face challenges, everyone wants to help them, but they prefer to rely on themselves. It's crucial for them to trust themselves, as this enables them to overcome obstacles. They are like a well - deep and sometimes appearing cold to others. It takes time to get to know them, they are strong-willed and clear-minded. Despite seeming aloof, they are actually very interesting and creative, with many ideas. When they hit rock bottom, they have the strength to pick themselves up, time and time again. They are excellent listeners when balanced.",
      "generalTitle": "General Description of Water Personalities",
      "generalDescription": "Someone with a strong Water element shows traits of fearlessness and determination. Such individuals have strong will power and succeed through difficulties owing to their mental strength. The organs associated with this element include the kidneys and bladder. In balance they will face their fears and vulnerabilities and then they can become successful and become the person they really are. These people normally prefer to be self-employed and are often workaholics. Out of balance they feel fearful, paranoid, indecisive and exhausted, often suffering from burn out. They may suffer from back pain, knee pain, and kidney &amp; bladder infections. Weakness in this element can result in hearing and hair loss, fertility and sexual organ imbalances. In some cases, people born under this element can suffer with feelings of insecurity, depression, fear, feeling overwhelmed, a lack of willpower, panic attacks, paranoia and timidity. Water personalities are old souls. They are wise, reflective, and private.",
      "attributes": {
        "organs": "Kidneys and Bladder",
        "season": "Winter",
        "weather": "Cold",
        "emotion": "Fear",
        "colour": "Black",
        "bodyTissue": "Bone",
        "sensation": "Hearing",
        "senseOrgan": "Ear",
        "sound": "Groaning",
        "taste": "Salt"
      },
      "physicalBoxTitle": "Gall Bladder/Liver – Wood",
      "physicalBoxText": "Physically this person also needs to keep their GB or LIV meridians balanced. An imbalance could create oiliness or dryness due to an imbalance of sebum in their skin, poor or excellent eyesight and muscular aches and pains.",
      "emotionalBoxTitle": "Bladder /Kidney – Water",
      "emotionalBoxText": "These people will be strong willed and stubborn. They know what they want to get out of life, and they will go and get it. They prefer to be self-employed than work for someone as they want to use their ideas. They need to make sure they don’t get burned out and may often feel tired."
    },
    "earth-roof": {
      "title": "EARTH ROOF",
      "element": "Earth",
      "meridians": "SI/TH H.P P/TW",
      "mainDescription": "These individuals crave balance and harmony in their lives, they are passionate and dislike routine. They constantly seek newness and new beginnings. They desire the protection and security a roof offers. They are deeply passionate and love wholeheartedly, with no middle ground. They are full of enthusiasm and warmth, often maternal and protective of their loved ones. They may tend to be possessive at times. Food is important to them, and if they lack affection, they may overeat and gain weight, particularly around the chest and heart area. They are like an Italian Mamma, seeking balance and contentment in life, prioritising simplicity over material possessions.",
      "generalTitle": "General Description of Earth personalities:",
      "generalDescription": "An Earth person is nurturing, generous, and caring. Earth personalities can be worrisome and pensive. They may suffer from abdominal issues or hormonal problems. Individuals who possess a strong element of earth are extremely compassionate and like everything in their life to be organised and balanced – neat and tidy. If their Earth element is lacking in energy this person may think too much, making mountains out of molehills and worrying excessively. They may have digestive problems and find their stomach bloats after eating. Food is very important; they normally wake up hungry and needing breakfast – breakfast is very important for them and should be eaten between 7 and 9 in the morning. The Earth Element person is a nurturer, they enjoy hosting family gatherings and thinking about the people they love. When Earth Element is out of balance some of the emotional symptoms they might experience are: confusion, craving sweet foods, feeling ungrounded, insecurity or neediness, obsessive thoughts, being over-protective, worrying, building up walls or barriers to protect themselves and burying their heads in the sand to avoid problems.",
      "attributes": {
        "organs": "Spleen and Stomach",
        "season": "Late Summer",
        "weather": "Damp",
        "emotion": "Worry",
        "colour": "Yellow",
        "bodyTissue": "Connective",
        "senseOrgan": "Mouth, Lips",
        "sound": "Singing",
        "taste": "Sweet"
      },
      "physicalBoxTitle": "Small Intestine/Triple Warmer Heart.Pericardium – Fire",
      "physicalBoxText": "Physically this person may have problems with their circulation. They may get cold hands and feet or warm hands and feet. They may also find they either perspire excessively or not at all.",
      "emotionalBoxTitle": "Pericardium/Triple Warmer – Fire",
      "emotionalBoxText": "This person will be a very warm, friendly and emotive person. They will either be very talkative or when things upset them find it hard to express themselves and get their words out."
    },
    "fire-lightening": {
      "title": "FIRE LIGHTENING",
      "element": "Fire",
      "meridians": "STO/SPL GB/LIV",
      "mainDescription": "These individuals are loyal and honest, never resorting to lies. They believe that their thoughts shape their reality. They are quick to act when they see something, like a bolt of lightning making an impact. Their creativity fuels them, but if they don’t express this creativity, they become stressed, and their fiery temper erupts. They have a quick temper, but it doesn’t last long. They are highly creative and artistic, but they need psychological and emotional balance to be able to showcase their skills effectively.",
      "generalTitle": "General Description of Fire Personalities",
      "generalDescription": "When in balance a Fire person likes to step into the limelight, showing off their gifts and beauty, sharing their truth. They love to be the centre of attention and feel full of love, joy and passion. Individuals with a strong element of fire usually have a very charismatic personality. They can be quick tempered, but their temper goes as fast as it came. They make excellent leaders; they are friendly and are very good at socialising. They wear their hearts on their sleeves, and you know exactly how they are feeling. They can be loud and full of energy, they attract people to them and to their energy and because of this they normally have a large circle of friends When Fire energy is out of balance, they can be impulsive and on occasion get irritable. Fire personalities may find it hard to express themselves when they are blocked and find that their words get stuck in their throats which can lead to confusion, insomnia and speech problems. Their circulation can either be very good or they can suffer from cold hands and feet. They may perspire very little or excessively. Fire people often have broken capillaries on their cheeks and a reddish complexion. When out of balance agitation, anxiety, continuous laughter, a lack of joy, self-love or humour may be felt along with poor self-esteem, and they may seem uncharacteristically quiet. Love is the most important thing in life to them – not always receiving love, often being able to share it.",
      "attributes": {
        "organs": "Heart, Small Intestine, Pericardium, Triple Warmer",
        "season": "Summer",
        "weather": "Heat",
        "emotion": "Joy",
        "colour": "Red",
        "bodyTissue": "Blood Vessels",
        "sensation": "Taste",
        "senseOrgan": "Tongue",
        "sound": "Laughing",
        "taste": "Bitter"
      },
      "physicalBoxTitle": "Stomach/Spleen - Earth",
      "physicalBoxText": "This person needs to watch their stomach physically. This means they could have digestive problems or problems with their skin – perhaps dullness or spots when younger. They may also get cellulite. Eating well is really important -good healthy food, and not too many sweet things. They may get bloating or stomach issues if they become imbalanced or blocked",
      "emotionalBoxTitle": "Gall Bladder/Liver – Wood",
      "emotionalBoxText": "This person has a lot of the emotional traits of a wood personality as well as the personality of their main element. A Wood personality can experience frustration and grumpiness, they may get a little ‘aggy’ or aggravated. They like to plan and organise. When they feel angry or frustrated, they should head to the gym or do something creative to help ease their feelings. Very often these people are very creative."
    },
    "wood-pine": {
      "title": "WOOD PINE",
      "element": "Wood",
      "meridians": "LI/LU LU/LI",
      "mainDescription": "These individuals keep their energy and ideas hidden inside of themselves, feeling content with that. They crave newness in their lives and constantly seek balance while pursuing their goals. They are very sensitive and want to build some meaning into their lives. They are adaptable, just like a Pine Tree they can thrive in both dry and wet conditions. Creative and with good ideas, they express themselves well and love smells, especially the scent of perfumes. They are resilient and adaptable, able to withstand any situation, remaining soft and sensitive. They should be mindful not to keep everything inside of themselves, as it could affect their physical health, particularly their Large Intestine.",
      "generalTitle": "General Description of Wood Personalities",
      "generalDescription": "Wood people may be seen as athletic, energetic, and adventurous. Their body type is generally muscled, and they easily obtain muscular definition when they work out. Their body shape is often long and strong like a tree. They have their best ideas at night and therefore tend to stay up late and hate early mornings! However, if this person’s energy is out of balance, they may feel stuck. They may find themselves unable to move forward or to plan their futures. Wood’s upsurging energy doesn’t like to be stuck or blocked, and therefore emotions of frustration and irritability can build up inside them like a pressure cooker. They may have angry outbursts and mood swings, and challenges become stressful to them. When blocked they may find they lose sight of their goals and visions and flitter between plans and stop looking to the future. Their optimism, energy and creativity fades. Wood personalities when blocked, tend to be anxious and angry. They may suffer from muscular aches and pains, migraines or headaches. They may have eye strain or eyesight problems. To rebalance avoid tv and computer screens, walk in a wood, look at the green beauty of the outside and breathe in natures energy. When in balance they are life’s organisers and planners and make great leaders.",
      "attributes": {
        "organs": "Liver and Gallbladder",
        "season": "Spring",
        "weather": "Wind",
        "emotion": "Anger",
        "colour": "Green",
        "bodyTissue": "Muscles and Tendons",
        "senseOrgan": "Eyes",
        "sound": "Shouting",
        "taste": "Sour"
      },
      "physicalBoxTitle": "Large Intestine/Lungs – Metal",
      "physicalBoxText": "Physically this person also needs to keep their LI or LU meridians balanced. An imbalance in their LU meridian could create asthma and breathing difficulties, or they could catch colds easily. An imbalance in their LI meridian could reveal itself as IBS, bowel irregularities or perhaps bloating or food intolerances",
      "emotionalBoxTitle": "Lungs/Large Intestine – Metal",
      "emotionalBoxText": "This person will also take on the emotional personality traits of a Metal Element. They may be very sensitive individuals and when something upsets or hurts them, they may find that they find it hard to let it go. They may still be holding on to things that hurt them years ago."
    },
    "water-flowing-long": {
      "title": "WATER FLOWING",
      "element": "Water",
      "meridians": "B/K STO/SPL",
      "mainDescription": "These people can over think things and refuse to listen to the advice of other people when they are blocked. Water is always flowing – these people don’t like to listen to the advice of others, and just like Water, they want to keep going, flowing onwards. They do what they want to do and to them it causes no problems - the water just keeps flowing. However, if they do not control their emotions they can suffer with water retention, and an unclear mind. When they are in balance and make their own decisions, they can be strong willed. This biorhythm creates a very strong person who at the same time is very fragile. If they become out of balance, they will just follow the crowd and listen to other people’s decisions and not their own.",
      "generalTitle": "General Description of Water Personalities",
      "generalDescription": "Someone with a strong Water element shows traits of fearlessness and determination. Such individuals have strong will power and succeed through difficulties owing to their mental strength. The organs associated with this element include the kidneys and bladder. In balance they will face their fears and vulnerabilities and then they can become successful and become the person they really are. These people normally prefer to be self-employed and are often workaholics. Out of balance they feel fearful, paranoid, indecisive and exhausted, often suffering from burn out. They may suffer from back pain, knee pain, and kidney and bladder infections. Weakness in this element can result in hearing and hair loss, fertility and sexual organ imbalances. In some cases, people born under this element can suffer with feelings of insecurity, depression, fear, feeling overwhelmed, a lack of willpower, panic attacks, paranoia and timidity. Water personalities are old souls. They are wise, reflective, and private.",
      "attributes": {
        "organs": "Kidneys and Bladder",
        "season": "Winter",
        "weather": "Cold",
        "emotion": "Fear",
        "colour": "Black",
        "bodyTissue": "Bone",
        "sensation": "Hearing",
        "senseOrgan": "Ear",
        "sound": "Groaning",
        "taste": "Salt"
      },
      "physicalBoxTitle": "Bladder/Kidney - Water",
      "physicalBoxText": "Blockages or stagnant energy in the Bladder or Kidney meridians may mean that this person could see problems like bladder infections, cystitis, gynaecological/reproductive organ problems, hearing problems or water retention.",
      "emotionalBoxTitle": "Stomach/Spleen – Earth",
      "emotionalBoxText": "Emotionally this person will also take on the personality traits of an Earth person. They can be nervous, a worrier, can make mountains out of molehills, may think about food a lot, and may hide their emotions"
    },
    "metal-gold-beneath-the-sand": {
      "title": "METAL GOLD BENEATH THE SAND",
      "element": "Metal",
      "meridians": "GB/LIV H/SI",
      "mainDescription": "It's important for these individuals to maintain a healthy body. The Fire in their biorhythm represents intuition, making them warm and sensitive, valuing everything. When they feel good about themselves and in balance they can achieve wealth and success because they will be proactive, social, and good at communicating. If they express their feelings and appreciate what they have, they can add value to their lives and earn money easily. However, they must avoid keeping everything hidden inside themselves and be mindful not to lose what they already possess.",
      "generalTitle": "General Description Metal personalities:",
      "generalDescription": "When out of balance Metal people can be hyper critical, over disciplined, direct and cold. They may wallow in grief, lose their self-worth and become depressed. A Metal personality is meticulous, honest, and responsible. Their personalities tend to be melancholy, and they may suffer from constipation, lung and skin issues, or allergies. Someone with a strong Metal element is usually very self-disciplined and organised. When an imbalance occurs in this element, the individual can feel very sad and melancholy and can develop problems related to the lungs, such as recurring colds, allergies and asthma. They feel more comfortable with clearly defined boundaries, rules, and expectations. When out of balance some of the emotional symptoms they might experience are apathy, boredom, grief, an inability to let go of the past, a lack of inspiration, melancholy, sadness and timidity.",
      "attributes": {
        "organs": "Lungs and Large Intestine",
        "season": "Autumn",
        "weather": "Dry",
        "emotion": "Grief",
        "colour": "White/Blue",
        "bodyTissue": "Skin",
        "sensation": "Smell",
        "senseOrgan": "Nose",
        "sound": "Weeping",
        "taste": "Spicy"
      },
      "physicalBoxTitle": "Gall Bladder/Liver – Wood",
      "physicalBoxText": "Physically this person also needs to keep their GB or LIV meridians balanced. An imbalance could create oiliness or dryness due to an imbalance of sebum in their skin, poor or excellent eyesight and muscular aches and pains.",
      "emotionalBoxTitle": "Pericardium/Triple Warmer – Fire",
      "emotionalBoxText": "This person will be a very warm, friendly and emotive person. They will either be very talkative or when things upset them find it hard to express themselves and get their words out."
    },
    "fire-at-base-of-mountain": {
      "title": "FIRE AT BASE OF MOUNTAIN",
      "element": "Fire",
      "meridians": "SI.TH/H.P B/K",
      "mainDescription": "This person is a good communicator and wants to establish a strong relationship with others. Like a lion in its pride, they like to take care of and look after their families. When their energy is good, they possess a clear mind, strong will, and effective communication abilities. They have a warm heart and can have a quick temper. If they become emotional or upset they struggle to communicate and it can feel like their words are stuck in their throat, stopping them from expressing themselves easily. They are determined, warm-hearted, and can make good leaders. Like a fire at the base of a mountain and despite knowing how to reach the top of the mountain, they often remain where they are, at the base. This is because they think too much and think rather than act. The mountain represents a journey from the Earth to the Sky, where they can climb to explore their inner most feelings and find clarity of mind. This person can do this but often they won’t bother to, it’s because they know they can do it that they decide they don’t need to.",
      "generalTitle": "General Description of Fire Personalities",
      "generalDescription": "When in balance a Fire person likes to step into the limelight, showing off their gifts and beauty, sharing their truth. They love to be the centre of attention and feel full of love, joy and passion. Individuals with a strong element of fire usually have a very charismatic personality. They can be quick tempered, but their temper goes as fast as it came. They make excellent leaders; they are friendly and are very good at socialising. They wear their hearts on their sleeves, and you know exactly how they are feeling. They can be loud and full of energy, they attract people to them and to their energy and because of this they normally have a large circle of friends When Fire energy is out of balance, they can be impulsive and on occasion get irritable. Fire personalities may find it hard to express themselves when they are blocked and find that their words get stuck in their throats which can lead to confusion, insomnia and speech problems. Their circulation can either be very good or they can suffer from cold hands and feet. They may perspire very little or excessively. Fire people often have broken capillaries on their cheeks and a reddish complexion. When out of balance agitation, anxiety, continuous laughter, a lack of joy, self-love or humour may be felt along with poor self-esteem, and they may seem uncharacteristically quiet. Love is the most important thing in life to them – not always receiving love, often being able to share it.",
      "attributes": {
        "organs": "Heart, Small Intestine, Pericardium, Triple Warmer",
        "season": "Summer",
        "weather": "Heat",
        "emotion": "Joy",
        "colour": "Red",
        "bodyTissue": "Blood Vessels",
        "sensation": "Taste",
        "senseOrgan": "Tongue",
        "sound": "Laughing",
        "taste": "Bitter"
      },
      "physicalBoxTitle": "Small Intestine/Triple Warmer Heart.Pericardium – Fire",
      "physicalBoxText": "Physically this person may have problems with their circulation. They may get cold hands and feet or warm hands and feet. They may also find they either perspire excessively or not at all.",
      "emotionalBoxTitle": "Bladder /Kidney – Water.",
      "emotionalBoxText": "These people will be strong willed and stubborn. They know what they want to get out of life, and they will go and get it. They prefer to be self-employed than work for someone as they want to use their ideas. They need to make sure they don’t get burned out and may often feel tired."
    },
    "wood-trees-on-a-plane": {
      "title": "WOOD TREES ON A PLANE",
      "element": "Wood",
      "meridians": "STO/SPL P/TW",
      "mainDescription": "This individual is an excellent communicator who knows no limits. They have abundant mental energy and use it as they wish. They are patient, complete, and generous, always making the best out of life's experiences. Passionate and emotive, they turn their thoughts into reality and are realistic, harmonious, and balanced. They find balance in all experiences and can be alone and happy when needed. They sometimes isolate themselves to recharge internally but also enjoy being with others. They thrive on passion and creativity, disliking routine and constantly seeking new ideas and creations. However, if blocked, they struggle to communicate.",
      "generalTitle": "General Description of Wood Personalities",
      "generalDescription": "Wood people may be seen as athletic, energetic, and adventurous. Their body type is generally muscled, and they easily obtain muscular definition when they work out. Their body shape is often long and strong like a tree. They have their best ideas at night and therefore tend to stay up late and hate early mornings! However, if this person’s energy is out of balance, they may feel stuck. They may find themselves unable to move forward or to plan their futures. Wood’s upsurging energy doesn’t like to be stuck or blocked, and therefore emotions of frustration and irritability can build up inside them like a pressure cooker. They may have angry outbursts and mood swings, and challenges become stressful to them. When blocked they may find they lose sight of their goals and visions and flitter between plans and stop looking to the future. Their optimism, energy and creativity fades. Wood personalities when blocked, tend to be anxious and angry. They may suffer from muscular aches and pains, migraines or headaches. They may have eye strain or eyesight problems. To re- balance avoid tv and computer screens, walk in a wood, look at the green beauty of the outside and breathe in natures energy. When in balance they are life’s organisers and planners and make great leaders.",
      "attributes": {
        "organs": "Liver and Gallbladder",
        "season": "Spring",
        "weather": "Wind",
        "emotion": "Anger",
        "colour": "Green",
        "bodyTissue": "Muscles and Tendons",
        "senseOrgan": "Eyes",
        "sound": "Shouting",
        "taste": "Sour"
      },
      "physicalBoxTitle": "Stomach/Spleen - Earth",
      "physicalBoxText": "This person needs to watch their stomach physically. This means they could have digestive problems or problems with their skin – perhaps dullness or spots when younger. They may also get cellulite. Eating well is really important -good healthy food, and not too many sweet things. They may get bloating or stomach issues if they become imbalanced or blocked",
      "emotionalBoxTitle": "Pericardium/Triple Warmer – Fire",
      "emotionalBoxText": "This person will be a very warm, friendly and emotive person. They will either be very talkative or when things upset them find it hard to express themselves and get their words out."
    },
    "earth-wall": {
      "title": "EARTH WALL",
      "element": "Earth",
      "meridians": "LI/LU GB/LIV",
      "mainDescription": "This person keeps their feelings inside, they are very sensitive and need their body to be in good physical health to keep them in balance. Food is crucial for their well-being, affecting their mind and creativity. When their body feels good, they can be sensitive and artistic, but if not, confusion arises, making it difficult to express themselves. They require security and comfort, often needing tangible possessions or landmarks to feel secure. If they don’t have these, they feel insecure and struggle to recognise their own qualities. Building walls or possessions gives them a sense of power and direction in life. They thrive on organisation and need structure to feel grounded. Without it, they feel lost and lack spontaneity, preferring predictability and clear landmarks in life.",
      "generalTitle": "General Description of Earth Personalities",
      "generalDescription": "An Earth person is someone who is nurturing, generous, and caring. Earth personalities can be worrisome and pensive. They may suffer from abdominal issues or hormonal problems. Individuals who possess a strong element of Earth are extremely compassionate and like everything in their life to be organised and balanced – neat and tidy. If their Earth element is lacking in energy someone may think too much, making mountains out of molehills and worrying excessively. This person may have digestive problems and find their stomach bloats after eating. Food is very important; they normally wake up hungry and needing breakfast – breakfast is very important for them and should be eaten between 7 and 9 in the morning. The Earth Element person is a nurturer, they enjoy hosting family gatherings and thinking about the people they love. When Earth Element is out of balance some of the emotional symptoms they might experience are: confusion, craving sweet foods, feeling ungrounded, insecurity or neediness, obsessive thoughts, being over-protective, worrying, building up walls or barriers to protect themselves and burying their heads in the sand to avoid problems.",
      "attributes": {
        "organs": "Spleen and Stomach",
        "season": "Late Summer",
        "weather": "Damp",
        "emotion": "Worry",
        "colour": "Yellow",
        "bodyTissue": "Connective Tissue",
        "sensation": "Touch",
        "senseOrgan": "Mouth, Lips",
        "sound": "Singing",
        "taste": "Sweet"
      },
      "physicalBoxTitle": "Large Intestine/Lungs – Metal",
      "physicalBoxText": "Physically this person also needs to keep their LI or LU meridians balanced. An imbalance in their LU meridian could create asthma and breathing difficulties, or they could catch colds easily. An imbalance in their LI meridian could reveal itself as IBS, bowel irregularities or perhaps bloating or food intolerances.",
      "emotionalBoxTitle": "Gall Bladder/Liver – Wood",
      "emotionalBoxText": "This person has a lot of the emotional traits of a wood personality as well as the personality of their main element. A Wood personality can experience frustration and grumpiness, they may get a little ‘aggy’ or aggravated. They like to plan and organise. When they feel angry or frustrated, they should head to the gym or do something creative to help ease their feelings. Very often these people are very creative."
    },
    "metal-white-gold": {
      "title": "METAL WHITE GOLD",
      "element": "Metal",
      "meridians": "B/K LU/LI",
      "mainDescription": "This person is very sensitive with good intuition and a clear mind. They value purity and wisdom, but they struggle with their desire to be perfect. When they lack sensitivity, they become rigid and over organised, driven by fear of imperfection. They can be egotistical and only trust themselves unless others repeatedly assure them of their trustworthiness. Aromatherapy can help unblock their fear, allowing them to show their sensitivity. Despite challenges, they are loyal individuals who seek security and strive for perfection in everything.",
      "generalTitle": "General Description of Metal Personalities",
      "generalDescription": "When out of balance Metal people can be hyper critical, over disciplined, direct and cold.They may wallow in grief, lose their self-worth and become depressed. A Metal personality is meticulous, honest, and responsible. Their personalities tend to be melancholy, and they may suffer from constipation, lung and skin issues, or allergies. Someone with a strong Metal element is usually very self-disciplined and organised. When an imbalance occurs in this element, the individual can feel very sad and melancholy and can develop problems related to the lungs, such as recurring colds, allergies and asthma. They feel more comfortable with clearly defined boundaries, rules, and expectations. When out of balance some of the emotional symptoms they might experience are apathy, boredom, grief, an inability to let go of the past, a lack of inspiration, melancholy, sadness and timidity. www. ashmirabotanica.com",
      "attributes": {
        "organs": "Lungs and Large Intestine",
        "season": "Autumn",
        "weather": "Dry",
        "emotion": "Grief",
        "colour": "White/Blue",
        "bodyTissue": "Skin",
        "sensation": "Smell",
        "senseOrgan": "Nose",
        "sound": "Weeping",
        "taste": "Spicy"
      },
      "physicalBoxTitle": "Bladder/Kidney - Water",
      "physicalBoxText": "Blockages or stagnant energy in the Bladder or Kidney meridians may mean that this person could see problems like bladder infections, cystitis, gynaecological/reproductive organ problems, hearing problems or water retention..",
      "emotionalBoxTitle": "Lungs/Large Intestine – Metal",
      "emotionalBoxText": "This person will also take on the emotional personality traits of a Metal Element. They may be very sensitive individuals and when something upsets or hurts them, they may find that they find it hard to let it go. They may still be holding on to things that hurt them years ago. www. ashmirabotanica.com"
    },
    "fire-flame-candle": {
      "title": "FIRE FLAME CANDLE",
      "element": "Fire",
      "meridians": "GB/LIV STO/SPL",
      "mainDescription": "This person is driven by the need to provide and be useful. They seek balance, are creative, and artistic, with a lot of dynamism. Their physical health is crucial for them, and they excel as communicators, but expressing their creativity can sometimes lead to confusion due to their abundance of thoughts. They are warm, loving, and communicative. Like the gentle flame of a candle, they have a soft demeanour and are unselfish, eager to enlighten others and share their knowledge little by little. They make good teachers.",
      "generalTitle": "General Description of Fire Personalities",
      "generalDescription": "When in balance a Fire person likes to step into the limelight, showing off their gifts and beauty, sharing their truth. They love to be the centre of attention and feel full of love, joy and passion. Individuals with a strong element of fire usually have a very charismatic personality. They can be quick tempered, but their temper goes as fast as it came. They make excellent leaders; they are friendly and are very good at socialising. They wear their hearts on their sleeves, and you know exactly how they are feeling. They can be loud and full of energy, they attract people to them and to their energy and because of this they normally have a large circle of friends When Fire energy is out of balance, they can be impulsive and on occasion get irritable. Fire personalities may find it hard to express themselves when they are blocked and find that their words get stuck in their throats which can lead to confusion, insomnia and speech problems. Their circulation can either be very good or they can suffer from cold hands and feet. They may perspire very little or excessively. Fire people often have broken capillaries on their cheeks and a reddish complexion. When out of balance agitation, anxiety, continuous laughter, a lack of joy, self-love or humour may be felt along with poor self-esteem, and they may seem uncharacteristically quiet. Love is the most important thing in life to them – not always receiving love, often being able to share it.",
      "attributes": {
        "organs": "Heart, Small Intestine, Pericardium, Triple Warmer",
        "season": "Summer",
        "weather": "Heat",
        "emotion": "Joy",
        "colour": "Red",
        "bodyTissue": "Blood Vessels",
        "sensation": "Taste",
        "senseOrgan": "Tongue",
        "sound": "Laughing",
        "taste": "Bitter"
      },
      "physicalBoxTitle": "Gall Bladder/Liver – Wood",
      "physicalBoxText": "Physically this person also needs to keep their GB or LIV meridians balanced. An imbalance could create oiliness or dryness due to an imbalance of sebum in their skin, poor or excellent eyesight and muscular aches and pains.",
      "emotionalBoxTitle": "Stomach/Spleen – Earth",
      "emotionalBoxText": "Emotionally this person will also take on the personality traits of an Earth person. They can be nervous, a worrier, can make mountains out of molehills, may think about food a lot, and may hide their emotions"
    },
    "water-from-the-sky": {
      "title": "WATER FROM THE SKY",
      "element": "Water",
      "meridians": "SI.TH H.P H/SI",
      "mainDescription": "This person needs to keep their life in balance, they hate routine. Either everything feels great for this person, or everything feels really bad. When things feel bad, they can’t hear the positive words from those around them encouraging them that everything will be ok. Unless they can see it for themselves or feel it for themselves, they won’t believe it. This person needs constant re-newel and newness in their life. They need to be in control of every situation, if not they become impatient and feel insecure and uncomfortable. They like to control. Water From The Sky is rain - rain knows where it is going to fall. It falls straight -down from the sky to the earth. This person is very loyal, they never diversify, they just keep going – straight on. They are straight talking but can be stubborn. This person is very warm and friendly, they wear their heart on their sleeve and are very loyal, they have a clear mind and clear vision, they know where they want to go in life, and they will. They are strong willed and make good listeners.",
      "generalTitle": "General Description of Water Personalities",
      "generalDescription": "Someone with a strong Water element shows traits of fearlessness and determination. Such individuals have strong will power and succeed through difficulties owing to their mental strength. The organs associated with this element include the kidneys and bladder. In balance they will face their fears and vulnerabilities and then they can become successful and become the person they really are. These people normally prefer to be self-employed and are often workaholics. Out of balance they feel fearful, paranoid, indecisive and exhausted, often suffering from burn out. They may suffer from back pain, knee pain, and kidney and bladder infections. Weakness in this element can result in hearing and hair loss, fertility and sexual organ imbalances. In some cases, people born under this element can suffer with feelings of insecurity, depression, fear, feeling overwhelmed, a lack of willpower, panic attacks, paranoia and timidity. Water personalities are old souls. They are wise, reflective, and private.",
      "attributes": {
        "organs": "Kidneys and Bladder",
        "season": "Winter",
        "weather": "Cold",
        "emotion": "Fear",
        "colour": "Black",
        "bodyTissue": "Bone",
        "sensation": "Hearing",
        "senseOrgan": "Ear",
        "sound": "Groaning",
        "taste": "Salt"
      },
      "physicalBoxTitle": "Small Intestine.Triple Warmer Heart.Pericardium – Fire",
      "physicalBoxText": "Physically this person may have problems with their circulation. They may get cold hands and feet or warm hands and feet. They may also find they either perspire excessively or not at all.",
      "emotionalBoxTitle": "Pericardium/Triple Warmer – Fire",
      "emotionalBoxText": "This person will be a very warm, friendly and emotive person. They will either be very talkative or when things upset them find it hard to express themselves and get their words out."
    },
    "earth-floor": {
      "title": "EARTH FLOOR",
      "element": "Earth",
      "meridians": "STO/SPL B/K",
      "mainDescription": "This person is always searching for balance. They think a lot. They make good listeners when they are not feeling confused - they feel confused when they are not in control, they like to know what lies ahead, and don’t like the unforeseen. When this person feels insecure, they start planning and organising. It’s important for them to feel the earth beneath their feet. If they over think things they create fear and start to feel anxious and afraid and then they want to plan and organise everything even more. They don't like to take risks. They need to control every situation and need to keep moving, not standing still. When their mind is clear, their stress lifts and they don’t have to plan all the time. However, if they think too much, they put all their energy into organisation. Food is very important to them. They need to eat good quality, nutritious food, they may have a sweet tooth, but it is important that they don’t eat too many sweets, cakes and sugar otherwise their body could become ill.",
      "generalTitle": "General Description of Earth personalities:",
      "generalDescription": "An Earth person is nurturing, generous, and caring. Earth personalities can be worrisome and pensive. They may suffer from abdominal issues or hormonal problems. Individuals who possess a strong element of earth are extremely compassionate and like everything in their life to be organised and balanced – neat and tidy. If their Earth element is lacking in energy someone may think too much, making mountains out of molehills and worrying excessively. They may have digestive problems and find their stomach bloats after eating. Food is very important; they normally wake up hungry and needing breakfast – breakfast is very important for them and should be eaten between 7 and 9 in the morning. The Earth Element person is a nurturer, they enjoy hosting family gatherings and thinking about the people they love. When Earth Element is out of balance some of the emotional symptoms they might experience are: confusion, craving sweet foods, feeling ungrounded, insecurity or neediness, obsessive thoughts, being over-protective, worrying, building up walls or barriers to protect themselves and burying their heads in the sand to avoid problems.",
      "attributes": {
        "organs": "Spleen and Stomach",
        "season": "Late Summer",
        "weather": "Damp",
        "emotion": "Worry",
        "colour": "Yellow",
        "bodyTissue": "Connective Tissue",
        "sensation": "Touch",
        "senseOrgan": "Mouth, Lips",
        "sound": "Singing",
        "taste": "Sweet"
      },
      "physicalBoxTitle": "Stomach/Spleen - Earth",
      "physicalBoxText": "This person needs to watch their stomach physically. This means they could have digestive problems or problems with their skin – perhaps dullness or spots when younger. They may also get cellulite. Eating well is really important -good healthy food, and not too many sweet things. They may get bloating or stomach issues if they become imbalanced or blocked.",
      "emotionalBoxTitle": "Bladder /Kidney – Water.",
      "emotionalBoxText": "These people will be strong willed and stubborn. They know what they want to get out of life, and they will go and get it. They prefer to be self-employed than work for someone as they want to use their ideas. They need to make sure they don’t get burned out and may often feel tired"
    },
    "metal-gold-jewellery": {
      "title": "METAL GOLD JEWELLERY",
      "element": "Metal",
      "meridians": "LI/LU P/TH",
      "mainDescription": "These people are very sensitive and are very good communicators. When they are passionate about something they know no limit, however if things don’t go the way that they want them to they can feel agitated. Gold Jewellery is precious, and this person searches for quality, they value the precious things in their lives They speak and communicate well and with sensitivity, they use seduction to get what they want. They want to shine above everyone else, and they know that if others see their brightness, they will be attracted to it. When they feel that attraction, they talk a lot - they crave the interest of others and others are drawn to them because they know they can explain things to them in a language that they will understand.",
      "generalTitle": "General Description Metal personalities:",
      "generalDescription": "When out of balance Metal people can be hyper critical, over disciplined, direct and cold. They may wallow in grief, lose their self-worth and become depressed. A Metal personality is meticulous, honest, and responsible. Their personalities tend to be melancholy, and they may suffer from constipation, lung and skin issues, or allergies. Someone with a strong Metal element is usually very self-disciplined and organised. When an imbalance occurs in this element, the individual can feel very sad and melancholy and can develop problems related to the lungs, such as recurring colds, allergies and asthma. They feel more comfortable with clearly defined boundaries, rules, and expectations. When out of balance some of the emotional symptoms they might experience are apathy, boredom, grief, an inability to let go of the past, a lack of inspiration, melancholy, sadness and timidity.",
      "attributes": {
        "organs": "Lungs and Large Intestine",
        "season": "Autumn",
        "weather": "Dry",
        "emotion": "Grief",
        "colour": "White/Blue",
        "bodyTissue": "Skin",
        "sensation": "Smell",
        "senseOrgan": "Nose",
        "sound": "Weeping",
        "taste": "Spicy"
      },
      "physicalBoxTitle": "Large Intestine/Lungs – Metal",
      "physicalBoxText": "Physically this person also needs to keep their LI or LU meridians balanced. An imbalance in their LU meridian could create asthma and breathing difficulties, or they could catch colds easily. An imbalance in their LI meridian could reveal itself as IBS, bowel irregularities or perhaps bloating or food intolerances.",
      "emotionalBoxTitle": "Pericardium/Triple Warmer – Fire",
      "emotionalBoxText": "This person will be a very warm, friendly and emotive person. They will either be very talkative or when things upset them find it hard to express themselves and get their words out."
    },
    "wood-mulberry-tree": {
      "title": "WOOD MULBERRY TREE",
      "element": "Wood",
      "meridians": "B/K GB/LIV",
      "mainDescription": "Why do something simply when you can do it complicatedly? They often have lots of projects on the go at the same time, and this can lead to them feeling agitated and give them sleepless nights. They should try to do just one thing at a time. These people like to please. They have good memories. They only trust themselves and feel that no one else can do things as well as they can. A Mulberry tree is a compact, small, knobbly, strong tree with a lot of energy and power. This person has a lot of energy. They need to keep their body in good health, doing sport or exercise. To balance feelings of aggression or anger they should do something creative like art, baking or dance. This person needs to be part of a team, they like to provide for others. Good food is very important and so is massage to alleviate muscular aches and pains. They need to be happy in themselves and do the things they enjoy; this will enable them to open up. Sometimes they will put off doing things simply because they are afraid. They must be true to themselves - and love themselves first.",
      "generalTitle": "General Description of Wood Personalities",
      "generalDescription": "Wood people may be seen as athletic, energetic, and adventurous. Their body type is generally muscled, and they easily obtain muscular definition when they work out. Their body shape is often long and strong like a tree. They have their best ideas at night and therefore tend to stay up late and hate early mornings! However, if this person’s energy is out of balance, they may feel stuck. They may find themselves unable to move forward or to plan their futures. Wood’s upsurging energy doesn’t like to be stuck or blocked, and therefore emotions of frustration and irritability can build up inside them like a pressure cooker. They may have angry outbursts and mood swings, and challenges become stressful to them. When blocked they may find they lose sight of their goals and visions and flitter between plans and stop looking to the future. Their optimism, energy and creativity fades. Wood personalities when blocked, tend to be anxious and angry. They may suffer from muscular aches and pains, migraines or headaches. They may have eye strain or eyesight problems. To re-balance avoid tv and computer screens, walk in a wood, look at the green beauty of the outside and breathe in natures energy. When in balance they are life’s organisers and planners and make great leaders.",
      "attributes": {
        "organs": "Liver and Gallbladder",
        "season": "Spring",
        "weather": "Wind",
        "emotion": "Anger",
        "colour": "Green",
        "bodyTissue": "Muscles and Tendons",
        "senseOrgan": "Eyes",
        "sound": "Shouting",
        "taste": "Sour"
      },
      "physicalBoxTitle": "Bladder/Kidney - Water",
      "physicalBoxText": "Blockages or stagnant energy in the Bladder or Kidney meridians may mean that this person could see problems like bladder infections, cystitis, gynaecological/reproductive organ problems, hearing problems or water retention.",
      "emotionalBoxTitle": "Gall Bladder/Liver – Wood",
      "emotionalBoxText": "This person also has Wood Meridians in their Emotional Box as well as being a Wood Element therefore they would have very strong Wood characteristics."
    },
    "water-waterfall": {
      "title": "WATER WATERFALL",
      "element": "Water",
      "meridians": "GB/LIV LU/LI",
      "mainDescription": "These people are very sensitive and loyal, they are straight talking and frank. They are idealists - but it isn't easy to be an idealist - this isn't an ideal world! A Waterfall is a lot of very strong water which gives fertility, and just like a waterfall, this person knows where they want to go. They have a lot of energy. Waterfalls fall at great speed – these people are imaginative, artistic, and creative. A waterfall starts at the top of a mountain and comes down over lots of rocks, boulders and hard terrain. Just like a waterfall, this person can live through hard periods in their life that won't feel hard for them, they can cope with all that life throws at them. When this person is doing what they want to do, no one can stop them – when they have an objective they will follow it. They can come across as stubborn, but they are calm because they know where they are going, so they have no worries. If they have a problem – they say – ‘no worries - tomorrow is but another day’.",
      "generalTitle": "General Description of Water Personalities",
      "generalDescription": "Someone with a strong Water element shows traits of fearlessness and determination. Such individuals have strong will power and succeed through difficulties owing to their mental strength. The organs associated with this element include the kidneys and bladder. In balance they will face their fears and vulnerabilities and then they can become successful and become the person they really are. These people normally prefer to be self-employed and are often workaholics. Out of balance they feel fearful, paranoid, indecisive and exhausted, often suffering from burn out. They may suffer from back pain, knee pain, and kidney and bladder infections. Weakness in this element can result in hearing and hair loss, fertility and sexual organ imbalances. In some cases, people born under this element can suffer with feelings of insecurity, depression, fear, feeling overwhelmed, a lack of willpower, panic attacks, paranoia and timidity. Water personalities are old souls. They are wise, reflective, and private.",
      "attributes": {
        "organs": "Kidneys and Bladder",
        "season": "Winter",
        "weather": "Cold",
        "emotion": "Fear",
        "colour": "Black",
        "bodyTissue": "Bone",
        "sensation": "Hearing",
        "senseOrgan": "Ear",
        "sound": "Groaning",
        "taste": "Salt"
      },
      "physicalBoxTitle": "Gall Bladder/Liver – Wood",
      "physicalBoxText": "Physically this person also needs to keep their GB or LIV meridians balanced. An imbalance could create oiliness or dryness due to an imbalance of sebum in their skin, poor or excellent eyesight and muscular aches and pains..",
      "emotionalBoxTitle": "Lungs/Large Intestine – Metal",
      "emotionalBoxText": "This person will also take on the emotional personality traits of a Metal Element. They may be very sensitive individuals and when something upsets or hurts them, they may find that they find it hard to let it go. They may still be holding on to things that hurt them years ago."
    },
    "earth-in-sand": {
      "title": "EARTH IN SAND",
      "element": "Earth",
      "meridians": "SI/TH H/P STO/SPL",
      "mainDescription": "It is important for this person to look after their body properly and to eat well. They hate routine and want lots of change. They feel as if they don’t need anyone else in their life to help them – they think that their problems belong to them. They are like an ostrich who buries their head in the sand, they don’t want to see what is going on around them. If they could learn to communicate and express their feelings this would help them. They are warm, friendly people who want to achieve their goals and dreams. They search for harmony and balance, but they think too much! They blow things out of proportion - they make a mountain out of a mole hill and put problems where there don’t need to be any. Like an ostrich, they don’t want to see things how they are, they would prefer to bury their head in the sand until the problem goes away. When happy they are a warm, balanced person who knows what they want, but they are very independent.",
      "generalTitle": "General Description of Earth Personalities",
      "generalDescription": "An Earth person is someone who is nurturing, generous, and caring. Earth personalities can be worrisome and pensive. They may suffer from abdominal issues or hormonal problems. Individuals who possess a strong element of earth are extremely compassionate and like everything in their life to be organised and balanced – neat and tidy. If their Earth element is lacking in energy someone may think too much, making mountains out of molehills and worrying excessively. They may have digestive problems and find their stomach bloats after eating. Food is very important; they normally wake up hungry and needing breakfast – breakfast is very important for them and should be eaten between 7 and 9 in the morning. The Earth Element person is a nurturer, they enjoy hosting family gatherings and thinking about the people they love. When Earth Element is out of balance some of the emotional symptoms they might experience are confusion, craving sweet foods, feeling ungrounded, insecurity or neediness, obsessive thoughts, being over- protective, worrying, building up walls or barriers to protect themselves and burying their heads in the sand to avoid problems.",
      "attributes": {
        "organs": "Spleen and Stomach",
        "season": "Late Summer",
        "weather": "Damp",
        "emotion": "Worry",
        "colour": "Yellow",
        "bodyTissue": "Connective Tissue",
        "sensation": "Touch",
        "senseOrgan": "Mouth, Lips",
        "sound": "Singing",
        "taste": "Sweet"
      },
      "physicalBoxTitle": "Small Intestine/Triple Warmer Heart.Pericardium – Fire",
      "physicalBoxText": "Physically this person may have problems with their circulation. They may get cold hands and feet or warm hands and feet. They may also find they either perspire excessively or not at all.",
      "emotionalBoxTitle": "Stomach/Spleen – Earth",
      "emotionalBoxText": "Emotionally this person will also take on the personality traits of an Earth person. They can be nervous, a worrier, can make mountains out of molehills, may think about food a lot, and may hide their emotions"
    },
    "fire-sun": {
      "title": "FIRE SUN",
      "element": "Fire",
      "meridians": "STO/SPL H/SI",
      "mainDescription": "These people are great communicators. They are warm people who wear their hearts on their sleeves. They don’t like to ask for help, they are very independent. They think a lot and have brilliant ideas. They use their past experiences to guide them. They can switch from being happy to suddenly unhappy, but they mustn’t worry as everything works out well for these people, they are like cats that always land on their feet! The sun is very warm, and radiates a lot of energy, but unlike the sun, these people keep their energy to themselves. They like to shine and like others to see their brightness and their energy, making very good actors as like to play different roles. They burn with energy and want everyone to love them. They have lots of charm and when this person enters the room you cannot miss them, they have a lot of natural charisma.",
      "generalTitle": "General Description of Fire Personalities",
      "generalDescription": "When in balance a Fire person likes to step into the limelight, showing off their gifts and beauty, sharing their truth. They love to be the centre of attention and feel full of love, joy and passion. Individuals with a strong element of fire usually have a very charismatic personality. They can be quick tempered, but their temper goes as fast as it came. They make excellent leaders; they are friendly and are very good at socialising. They wear their hearts on their sleeves, and you know exactly how they are feeling. They can be loud and full of energy, they attract people to them and to their energy and because of this they normally have a large circle of friends When Fire energy is out of balance, they can be impulsive and on occasion get irritable. Fire personalities may find it hard to express themselves when they are blocked and find that their words get stuck in their throats which can lead to confusion, insomnia and speech problems. Their circulation can either be very good or they can suffer from cold hands and feet. They may perspire very little or excessively. Fire people often have broken capillaries on their cheeks and a reddish complexion. When out of balance agitation, anxiety, continuous laughter, a lack of joy, self-love or humour may be felt along with poor self-esteem, and they may seem uncharacteristically quiet. Love is the most important thing in life to them – not always receiving love, often being able to share it..",
      "attributes": {
        "organs": "Heart, Small Intestine, Pericardium, Triple Warmer",
        "season": "Summer",
        "weather": "Heat",
        "emotion": "Joy",
        "colour": "Red",
        "bodyTissue": "Blood Vessels",
        "sensation": "Taste",
        "senseOrgan": "Tongue",
        "sound": "Laughing",
        "taste": "Bitter"
      },
      "physicalBoxTitle": "Stomach/Spleen - Earth",
      "physicalBoxText": "This person needs to watch their stomach physically. This means they could have digestive problems or problems with their skin – perhaps dullness or spots when younger. They may also get cellulite. Eating well is really important -good healthy food, and not too many sweet things. They may get bloating or stomach issues if they become imbalanced or blocked.",
      "emotionalBoxTitle": "Heart/Small Intestine – Fire",
      "emotionalBoxText": "This person will be a very warm, friendly and emotive person. They wear their heart on their sleeve, and you always know what they are thinking and feeling. Love is very important to them."
    },
    "wood-pomegranate-tree": {
      "title": "WOOD POMEGRANATE TREE",
      "element": "Wood",
      "meridians": "LI/LU B/K",
      "mainDescription": "These people have very clear minds and are very creative. To achieve this, they need to look after and understand their physical bodies, perhaps with sport or exercise. They are very frank and cannot be what they are not, they are very true and honest people. These people are very creative and often become artists. They are very sensitive. They know where they are going in life. The pomegranate has a beautiful fruit with a lovely smell. This fruit is the result of the tree – these people produce beauty from what they create.",
      "generalTitle": "General Description of Wood Personalities",
      "generalDescription": "Wood people may be seen as athletic, energetic, and adventurous. Their body type is generally muscled, and they easily obtain muscular definition when they work out. Their body shape is often long and strong like a tree. They have their best ideas at night and therefore tend to stay up late and hate early mornings! However, if this person’s energy is out of balance, they may feel stuck. They may find themselves unable to move forward or to plan their futures. Wood’s upsurging energy doesn’t like to be stuck or blocked, and therefore emotions of frustration and irritability can build up inside them like a pressure cooker. They may have angry outbursts and mood swings, and challenges become stressful to them. When blocked they may find they lose sight of their goals and visions and flitter between plans and stop looking to the future. Their optimism, energy and creativity fades. Wood personalities when blocked, tend to be anxious and angry. They may suffer from muscular aches and pains, migraines or headaches. They may have eye strain or eyesight problems. To re-balance avoid tv and computer screens, walk in a wood, look at the green beauty of the outside and breathe in natures energy. When in balance they are life’s organisers and planners and make great leaders.",
      "attributes": {
        "organs": "Liver and Gallbladder",
        "season": "Spring",
        "weather": "Wind",
        "emotion": "Anger",
        "colour": "Green",
        "bodyTissue": "Muscles and Tendons",
        "senseOrgan": "Eyes",
        "sound": "Shouting",
        "taste": "Sour"
      },
      "physicalBoxTitle": "Large Intestine/Lungs – Metal",
      "physicalBoxText": "Physically this person also needs to keep their LI or LU meridians balanced. An imbalance in their LU meridian could create asthma and breathing difficulties, or they could catch colds easily. An imbalance in their LI meridian could reveal itself as IBS, bowel irregularities or perhaps bloating or food intolerances.",
      "emotionalBoxTitle": "Bladder /Kidney – Water.",
      "emotionalBoxText": "These people will be strong willed and stubborn. They know what they want to get out of life, and they will go and get it. They prefer to be self-employed than work for someone as they want to use their own ideas. They need to make sure they don’t get burned out and may often feel tired"
    },
    "water-vast-ocean": {
      "title": "WATER VAST OCEAN",
      "element": "Water",
      "meridians": "B/K P/TW",
      "mainDescription": "These people are very strong willed, make good listeners, and have a clear head. Water Vast Ocean is a LOT of water, just like the ocean this person knows no limits - no one can stop them. They are meticulous. Water holds a lot of riches and the richness in this person is their ability to explain things easily to others and give their knowledge generously. They share their knowledge with precision and can describe things very clearly. When they are in balance, they are very passionate and emotional however, if they become fearful, they may become anxious and afraid. There is no limit to this person’s capabilities, they can turn their hand to anything. Sometimes this can be overwhelming and because they have so much choice, they don’t know which way to turn. It can be very difficult to get to know who this person is because they are so vast - there is so much to them. There is no limit to what they can achieve.",
      "generalTitle": "General Description of Water Personalities",
      "generalDescription": "Someone with a strong Water element shows traits of fearlessness and determination. Such individuals have strong will power and succeed through difficulties owing to their mental strength. The organs associated with this element include the kidneys and bladder. In balance they will face their fears and vulnerabilities and then they can become successful and become the person they really are. These people normally prefer to be self-employed and are often workaholics. Out of balance they feel fearful, paranoid, indecisive and exhausted, often suffering from burn out. They may suffer from back pain, knee pain, and kidney and bladder infections. Weakness in this element can result in hearing and hair loss, fertility and sexual organ imbalances. In some cases, people born under this element can suffer with feelings of insecurity, depression, fear, feeling overwhelmed, a lack of willpower, panic attacks, paranoia and timidity. Water personalities are old souls. They are wise, reflective, and private. www. ashmirabotanica.com",
      "attributes": {
        "organs": "Kidneys and Bladder",
        "season": "Winter",
        "weather": "Cold",
        "emotion": "Fear",
        "colour": "Black",
        "bodyTissue": "Bone",
        "sensation": "Hearing",
        "senseOrgan": "Ear",
        "sound": "Groaning",
        "taste": "Salt"
      },
      "physicalBoxTitle": "Bladder/Kidney - Water",
      "physicalBoxText": "Blockages or stagnant energy in the Bladder or Kidney meridians may mean that this person could see problems like bladder infections, cystitis, gynaecological or reproductive organ problems, hearing problems or water retention.",
      "emotionalBoxTitle": "Pericardium/Triple Warmer – Fire",
      "emotionalBoxText": "This person will be a very warm, friendly and emotive person. They will either be very talkative or when things upset them find it hard to express themselves and get their words out. www. ashmirabotanica.com"
    }
  }
};
